<div class="cases_page tasks_page">
  <div class="container">
    <div class="filter_out" *ngIf="!is_mobile">  

      <div class="filter_values">
        <app-active-filters [section]="'Cards'" [company_id]="company_id" [filter]="filter" [filterValue]="filter.value" (RemoveValue)="removeValue($event)" (RemoveValueFromMultiple)="removeValueFromMultiple($event)"></app-active-filters>
        <div class="stats_wrp">
          <mat-slide-toggle (change)="selectChangeEs($event)"
              class="mr-1"
              [color]="'primary'"
              [checked]="isES"
              >
              <!-- [(ngModel)]="isES" -->
            V2
          </mat-slide-toggle>

          <div class="server_btn mr-1" [matMenuTriggerFor]="resultsMenu">
            <span>
              {{"All results" | translate}}
            </span>
          </div>

          <mat-menu #resultsMenu="matMenu" class="sort_tablet new_sort_int" xPosition='before' overlayPanelClass='sortTAB'>
            <button mat-menu-item (click)="addMultiWorks(true)">
              {{ "Add jobs" | translate }}
            </button>
            <button mat-menu-item (click)="importFilesV2(true)">
              {{ "Import Files" | translate }}
            </button>
            <button mat-menu-item (click)="addCardsScen(true)">
              {{ 'Set scenario' | translate }}
            </button>
            <button mat-menu-item (click)="openTargetValues([0, 0, 0], null, true)">
              {{ 'Add tags' | translate }}
            </button>
            <button mat-menu-item (click)="addChannels(true)">
              {{ "Add Outlets" | translate }}
            </button>
            <button mat-menu-item (click)="multiEditTaskStatus(true)">
              {{ "Edit task type" | translate }}
            </button>
            <button mat-menu-item (click)="multiDeleteCards(true)" [disabled]="multiDeletedCards">
              {{ "Delete Cards" | translate }}
            </button>
          </mat-menu>

          <div class="split_btns">
            <ng-container *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin')">
              <div class="split_btn" (click)="postsCleaner()" #tooltip="matTooltip" 
              matTooltip="{{'Cleaner' | translate}}"
              [matTooltipPosition]="'above'">
                <svg style="width: 16px; height: 16px;" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="m20 18h6v2h-6z" transform="matrix(-1 0 0 -1 46 38)"/><path d="m24 26h6v2h-6z" transform="matrix(-1 0 0 -1 54 54)"/><path d="m22 22h6v2h-6z" transform="matrix(-1 0 0 -1 50 46)"/><path d="m17.0029 20a4.8952 4.8952 0 0 0 -2.4044-4.1729l7.4015-12.8271-1.7309-1-7.5758 13.126a5.6988 5.6988 0 0 0 -5.2433 1.5029c-3.7436 3.6111-3.4537 12.0532-3.44 12.4111a1 1 0 0 0 1 .96h14.9912a1 1 0 0 0 .6-1.8c-3.5397-2.6561-3.5983-8.1463-3.5983-8.2zm-5.0729-3.0029a3.11 3.11 0 0 1 3.0741 3.0029c0 .0381.0019.208.0168.4688l-5.8994-2.6236a3.8 3.8 0 0 1 2.8085-.8481zm3.5194 11.0029a5.2 5.2 0 0 1 -1.4494-3h-2a6.4993 6.4993 0 0 0 .9684 3h-2.2233a16.6166 16.6166 0 0 1 -.7451-4h-2a17.3424 17.3424 0 0 0 .6652 4h-2.6652c.031-1.8364.29-5.8921 1.8027-8.5527l7.533 3.35a13.0253 13.0253 0 0 0 2.2611 5.2027z"/><path d="m0 0h32v32h-32z" fill="none"/></svg>
              </div>
              <div class="split_divider" style="height: 6px;"></div>
            </ng-container>
            
            <div class="split_btn" (click)="toggleCardExp()" #tooltip="matTooltip" 
            matTooltip="{{'Show relations to partner cards' | translate}}"
            [matTooltipPosition]="'above'">
              <svg style="width: 16px; height: 18px;" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.28886 8.08684L10.0021 5.10995" [ngStyle]="{'stroke': card_exp === 1 ? '#1877F2' : '#FD8C28'}"/>
                <line x1="5.29826" y1="10.3862" x2="10.2596" y2="13.363" [ngStyle]="{'stroke': card_exp === 1 ? '#1877F2' : '#FD8C28'}"/>
                <circle cx="2.85771" cy="9.42607" r="2.35771" [ngStyle]="{'stroke': card_exp === 1 ? '#1877F2' : '#FD8C28'}"/>
                <circle cx="12.3831" cy="3.71074" r="2.35771" [ngStyle]="{'stroke': card_exp === 1 ? '#1877F2' : '#FD8C28'}"/>
                <circle cx="12.3831" cy="15.1414" r="2.35771" [ngStyle]="{'stroke': card_exp === 1 ? '#1877F2' : '#FD8C28'}"/>
              </svg>
            </div>
            <div class="split_divider" style="height: 6px;"></div>
            <div class="split_btn" [matMenuTriggerFor]="compBtn" #tooltip="matTooltip" 
            matTooltip="{{'Card relations filter' | translate}}"
            [matTooltipPosition]="'above'">
              <svg style="width: 9px; height: 9px;" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_6406_65570)">
                <path d="M5.99983 4.49938V8.43883C6.01983 8.58881 5.96984 8.74879 5.85486 8.85377C5.65989 9.04874 5.34494 9.04874 5.14998 8.85377L4.14514 7.84891C4.03016 7.73393 3.98017 7.57895 4.00016 7.43397V4.49938H3.98517L1.10564 0.809888C0.935672 0.594917 0.975665 0.279961 1.19063 0.109985C1.28561 0.0399945 1.3906 0 1.50058 0H8.49942C8.6094 0 8.71439 0.0399945 8.80937 0.109985C9.02433 0.279961 9.06433 0.594917 8.89436 0.809888L6.01483 4.49938H5.99983Z" fill="#757575"/>
                </g>
                <defs>
                <filter id="filter0_d_6406_65570" x="0" y="0" width="9" height="9" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="-1"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6406_65570"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6406_65570" result="shape"/>
                </filter>
                </defs>
              </svg>
            </div>
            <mat-menu #compBtn="matMenu" class="sort_tablet new_sort_int" xPosition='before' overlayPanelClass='sortTAB'>
              <div class="mat-menu-title">{{"Relations filter" | translate}}:</div>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="compFilter('is_related_task', filter?.get('is_related_task')?.value === 1 ? '' : 1)" [ngClass]="{'active_status': filter?.get('is_related_task')?.value === 1}">
                {{ "Used in related" | translate }}
              </button>
              <button mat-menu-item (click)="compFilter('is_related_task', filter?.get('is_related_task')?.value === 0 ? '' : 0)" [ngClass]="{'active_status': filter?.get('is_related_task')?.value === 0}">
                {{ "Never used in related" | translate }}
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="compFilter('is_consist_of_task', filter?.get('is_consist_of_task')?.value === 1 ? '' : 1)" [ngClass]="{'active_status': filter?.get('is_consist_of_task')?.value === 1}">
                {{ "Used in consist of" | translate }}
              </button>
              <button mat-menu-item (click)="compFilter('is_consist_of_task', filter?.get('is_consist_of_task')?.value === 0 ? '' : 0)" [ngClass]="{'active_status': filter?.get('is_consist_of_task')?.value === 0}">
                {{ "Never used in consist of" | translate }}
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="compFilter('is_part_of_task', filter?.get('is_part_of_task')?.value === 1 ? '' : 1)" [ngClass]="{'active_status': filter?.get('is_part_of_task')?.value === 1}">
                {{ "Used in part of" | translate }}
              </button>
              <button mat-menu-item (click)="compFilter('is_part_of_task', filter?.get('is_part_of_task')?.value === 0 ? '' : 0)" [ngClass]="{'active_status': filter?.get('is_part_of_task')?.value === 0}">
                {{ "Never used in part of" | translate }}
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="compilationAssistant()">
                {{ "Custom filter" | translate }}
              </button>
            </mat-menu>
            <ng-container *ngIf="tasks && tasks.length && company?.permissions.includes('create_task')">
              <div class="split_divider"></div>
              <div class="split_btn" (click)="compilations()" #tooltip="matTooltip" 
              matTooltip="{{'Compilations wizard' | translate}}"
              [matTooltipPosition]="'above'">
                <svg style="width: 11px; height: 6px;" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0V1.2H2.75V0H0ZM5.5 1.2V2.4H3.85V3.6H5.5V4.8L7.15 3L5.5 1.2ZM8.25 1.2V4.8H11V1.2H8.25ZM0 2.4V3.6H2.75V2.4H0ZM0 4.8V6H2.75V4.8H0Z" fill="#686868"/>
                </svg>                
              </div>
            </ng-container>
            <ng-container *ngIf="bookmarks && bookmarks.length > 0">
              <div class="split_divider"></div>
              <form [formGroup]="filter">
                <div class="split_btn" (click)="presetFilter.open()" #tooltip="matTooltip" 
                matTooltip="{{'Presets' | translate}}"
                [matTooltipPosition]="'above'">
                  <svg style="width: 10px; height: 12px;" width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333V12L4.66667 10L9.33333 12V1.33333C9.33333 0.593333 8.73333 0 8 0Z" fill="#686868"/>
                  </svg>
                  <mat-form-field appearance="legacy" class="split_btn_select">
                    <mat-label>{{ "Preset" | translate }}</mat-label>
                    <mat-select #presetFilter [disableOptionCentering]="true" selectDir formControlName="preset_id" (selectionChange)="bookmarksChange($event)">
                        <mat-option *ngIf="bookmarks.length > 7">
                          <ngx-mat-select-search 
                              placeholderLabel="{{ 'Search' | translate }}" 
                              noEntriesFoundLabel="{{ 'no matching presets found' | translate }}"
                              [formControl]="bookmarksControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let bookmark of bookmarks$ | async" [value]="bookmark.id">
                          {{ bookmark.name | translate }}
                        </mat-option>
                    </mat-select>
                  </mat-form-field>             
                </div>
              </form>
            </ng-container>
            

          </div>

          <div class="tasks_counters">

            <div class="counter_block" *ngIf="tasks?.length">
              <div class="counter_top">{{ "Cards" | translate }}</div>
              <div class="counter_bottom cp" (click)="getTasksCount(); getHeaderStats();">
                <ng-container *ngIf="!!totalTasksCount; else elseTemplatetotalTasksCountMob">
                  {{tasks?.length}} / <b>{{totalTasksCount}}</b>
                </ng-container>
                <ng-template #elseTemplatetotalTasksCountMob>
                  {{ tasks?.length }}<ng-container *ngIf="hasMore">+</ng-container>
                </ng-template>
              </div>
            </div>
            
            <ng-container *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager'); else iAmOwner">
              <div class="counter_block" *ngIf="totalInfo['summaryRate']">
                <div class="counter_top">{{ "pts" | translate }}</div>
                <div class="counter_bottom">{{ totalInfo['summaryRate'] | reportsNumber }}</div>
              </div>
              <ng-container *ngFor="let cPrice of totalInfo['summaryPrice']; let i = index">
                <div class="counter_block" *ngIf="cPrice.summary != '0'">
                  <div class="counter_top">
                    {{cPrice.iso_name}}
                  </div>
                  <div class="counter_bottom">{{ cPrice.summary | reportsNumber }}</div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #iAmOwner>
              <div class="counter_block" *ngIf="!!totalInfo['totalPrice'] || !!totalInfo['summaryRate']">
                <div class="counter_top">{{ "Earnings" | translate }}</div>
                <div class="counter_bottom">
                  <span>{{ totalInfo['summaryRate'] | reportsNumber }} {{ "pts" | translate }}</span>
                  <ng-container *ngFor="let cPrice of totalInfo['summaryPrice']; let i = index">
                    <span *ngIf="cPrice.summary != '0'">
                      {{ cPrice.summary | reportsNumber }}
                      <span class="currency_bottom" [ngSwitch]="cPrice.currency_id">
                        {{cPrice.iso_name}}              
                      </span>
                    </span>
                  </ng-container>
                </div>
              </div>
    
              <div class="empl_info" *ngIf="!!company && company.permissions.includes('employee') && !!company.hasOwnProperty('rate_pending') && !!company.hasOwnProperty('rate_ready') && !!company.hasOwnProperty('price_ready') && !!company.hasOwnProperty('price_pending') && !is_mobile">
                <ng-container *ngIf="+company.rate_target != 0;">
                  <div class="percent" *ngIf="+company?.rate_target > 0">
                    {{ ((+company?.rate_pending + +company?.rate_ready) / +company?.rate_target)*100 | reportsNumber }}%
                  </div>
                  <div class="counter_block">
                    <div class="counter_top">{{ currMonthName }} {{ "earnings" | translate }}</div>
                    <div class="counter_bottom">{{ (+company?.rate_pending + +company?.rate_ready) | reportsNumber }} {{"pts" | translate}} {{ "of" | translate }} {{ +company?.rate_target | reportsNumber }}</div>
                  </div>
                  <div class="hover_stats">
                    <div>{{ (+company?.rate_ready / +company?.rate_target)*100 | reportsNumber }}% {{ "Ready" | translate }}</div>
                    <div>{{ (+company?.rate_pending / +company?.rate_target)*100 | reportsNumber }}% {{ "Pending" | translate }}</div>
                  </div>
                </ng-container>
                <ng-container *ngIf="+company.salary != 0">
                  <div class="percent" *ngIf="+company?.salary > 0">
                    {{ ((+company?.price_ready + +company?.price_pending) / +company?.salary)*100 | reportsNumber }}% 
                  </div>
                  <div class="counter_block">
                    <div class="counter_top">{{ currMonthName }} {{ "earnings" | translate }}</div>
                    <div class="counter_bottom">
                      <ng-container [ngSwitch]="company?.currency_id">
                        <ng-container *ngSwitchCase="'1'">&#36;</ng-container>
                        <ng-container *ngSwitchCase="'2'">&#8381;</ng-container>
                        <ng-container *ngSwitchCase="'3'">&#8364;</ng-container>
                        <ng-container *ngSwitchCase="'4'">&#8372;</ng-container>
                      </ng-container>{{ company?.price_ready | reportsNumber }}
                      {{ "of" | translate }} 
                      <ng-container [ngSwitch]="company?.currency_id">
                          <ng-container *ngSwitchCase="'1'">&#36;</ng-container>
                          <ng-container *ngSwitchCase="'2'">&#8381;</ng-container>
                          <ng-container *ngSwitchCase="'3'">&#8364;</ng-container>
                          <ng-container *ngSwitchCase="'4'">&#8372;</ng-container>
                      </ng-container>{{ company?.salary | reportsNumber }}
                    </div>
                  </div>
                  <div class="hover_stats">
                    <div>{{ (+company?.price_ready / +company?.salary)*100 | reportsNumber }}% {{ "Ready" | translate }}</div>
                    <div>{{ (+company?.price_pending / +company?.salary)*100 | reportsNumber }}% {{ "Pending" | translate }}</div>
                  </div>
                </ng-container>
              </div>
            </ng-template>
            <button type="button" mat-icon-button (click)="refreshPage()" #tooltip="matTooltip"
            matTooltip="{{ 'Refresh results on the page' | translate }}"
            [matTooltipPosition]="'above'">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="expands_wrp">
        <div class="d-f-c">
          <ng-container *ngIf="!isES">
            <div class="expand" [ngClass]="{'active': !expandValues().includes(false)}" (click)="toggleExp('all', !expandValues().includes(false))">{{"All" | translate}}</div>
            <ng-container *ngFor="let key of expandKeys()">
              <div class="expand" [ngClass]="{'active': cardsExpand[key]}" (click)="toggleExp(key, cardsExpand[key])">{{ key | translate }}</div>
            </ng-container>
          </ng-container>
          
        </div>
        <div class="d-f-c">
          <div class="expand" [ngClass]="{'active': filter.get('origin_company_id').value == company_id}" (click)="setOrigCompany(company_id)">{{"This Workspace" | translate}}</div>
          <div class="expand" [ngClass]="{'active': filter.get('origin_company_id').value === 0}" (click)="setOrigCompany('0')">{{"This and partner workspaces" | translate}}</div>
        </div>
      </div>
    </div>

    <div class="lists_wrp" *ngIf="!is_mobile">
      <div class="check_wrp">
        <mat-checkbox class="select_all_checkbox" *ngIf="taskCollection" (click)="$event.preventDefault; $event.stopPropagation()" (change)="$event ? masterToggle() : null"
          [checked]="taskCollection.hasValue() && isAllSelected()"
          [indeterminate]="taskCollection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </div>
      <div class="job_status_wrp" [ngClass]="{'active': activeStatus.includes(0)}">
        <button mat-button  (click)='changeActiveStatus(0, $event)' [ngClass]="{'active_status': activeStatus.includes(0)}">{{ "All" | translate }}</button>
      </div>
      <div class="job_status_wrp" [ngClass]="{'active': activeStatus.length == 3 && activeStatus.includes(1) && activeStatus.includes(2) && activeStatus.includes(5)}">
        <button mat-button (click)='changeActiveStatus([1,2,5], $event)' [ngClass]="{'active_status': activeStatus.length == 3 && activeStatus.includes(1) && activeStatus.includes(2) && activeStatus.includes(5)}">{{ "All to do" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(1, $event)' [ngClass]="{'active_status': activeStatus.includes(1) && activeStatus.length != 3}">{{ "Waiting" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(2, $event)' [ngClass]="{'active_status': activeStatus.includes(2) && activeStatus.length != 3}">{{ "In process" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(5, $event)' [ngClass]="{'active_status': activeStatus.includes(5) && activeStatus.length != 3}">{{ "To correct" | translate }}</button>
      </div>

      <div class="job_status_wrp" [ngClass]="{'active': activeStatus.length == 6 && activeStatus.includes(3) && activeStatus.includes(4) && activeStatus.includes(6) && activeStatus.includes(97) && activeStatus.includes(98) && activeStatus.includes(99)}">
        <button mat-button (click)='changeActiveStatus([3,4,6,97,98,99], $event)' [ngClass]="{'active_status': activeStatus.length == 6 && activeStatus.includes(3) && activeStatus.includes(4) && activeStatus.includes(6) && activeStatus.includes(97) && activeStatus.includes(98) && activeStatus.includes(99)}">{{ "All done" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(3, $event)' [ngClass]="{'active_status': activeStatus.includes(3) && activeStatus.length != 6}">{{ "To approve" | translate }}</button>
        <ng-container *ngIf="hasReminder; else elseTemplateHasReminderDesk">
          <button mat-button (click)='goToReminderCases()' [ngClass]="{'red': hasReminder}">
              {{ "To Finalize" | translate }}
            </button>
            <button mat-button (click)='changeActiveStatus(4, $event)' [ngClass]="{'active_status': activeStatus.includes(4) && activeStatus.length != 6}">
              {{ "Approved" | translate }}
            </button>
          </ng-container>
        <ng-template #elseTemplateHasReminderDesk>
          <button mat-button (click)='changeActiveStatus(4, $event)' [ngClass]="{'active_status': activeStatus.includes(4) && activeStatus.length != 6}">
            {{ "Approved" | translate }}
          </button>
        </ng-template>
        <button mat-button (click)='changeActiveStatus(6, $event)' [ngClass]="{'active_status': activeStatus.includes(6) && activeStatus.length != 6}">{{ "Sources needed" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(97, $event)' [ngClass]="{'active_status': activeStatus.includes(97) && activeStatus.length != 6}">{{ "On hold" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(98, $event)' [ngClass]="{'active_status': activeStatus.includes(98) && activeStatus.length != 6}">{{ "Ready" | translate }}</button>
        <button mat-button (click)='changeActiveStatus(99, $event)' [ngClass]="{'active_status': activeStatus.includes(99) && activeStatus.length != 6}">{{ "Canceled" | translate }}</button>
      </div>

      <mat-button-toggle-group class="view_group" (change)="changeView($event)" [value]="filter.get('operation_employee_id').value == me?.id ? 'executor' : 'client'">
        <mat-button-toggle value="client">{{ "As client" | translate }}</mat-button-toggle>
        <mat-button-toggle value="executor">{{ "As executor" | translate }}</mat-button-toggle>
      </mat-button-toggle-group>
      
      <button type="button" mat-icon-button [matMenuTriggerFor]="sortBtn" class="mobActiveFilter" #tooltip="matTooltip" matTooltip="{{ 'Sort' | translate }}" [matTooltipPosition]="'above'">
        <mat-icon>sort</mat-icon>
      </button>

      <mat-menu #sortBtn="matMenu" class="sort_tablet new_sort_int" xPosition='before' overlayPanelClass='sortTAB'>
        <div class="mat-menu-title">{{"Sort By" | translate}}:</div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="sort(sortValue == 'updated_desc' ? 'updated' : 'updated_desc')" [ngClass]="{'active_status': sortValue == 'updated_desc' || sortValue == 'updated'}">
          {{  "Updated" | translate }}
          <div class="d-f-c ml-1">
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('updated_desc')" [ngClass]="{'active': sortValue == 'updated_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('updated')" [ngClass]="{'active': sortValue == 'updated'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
          </div>
        </button>
        <button mat-menu-item (click)="sort(sortValue == 'priority_desc' ? 'priority' : 'priority_desc')" [ngClass]="{'active_status': sortValue == 'priority_desc' || sortValue == 'priority'}">
          {{  "Priority" | translate }}
          <div class="d-f-c ml-1">
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('priority_desc')" [ngClass]="{'active': sortValue == 'priority_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('priority')" [ngClass]="{'active': sortValue == 'priority'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
          </div>
        </button>
        <button mat-menu-item (click)="sort(sortValue == 'custom_id_desc' ? 'custom_id' : 'custom_id_desc')" [ngClass]="{'active_status': sortValue == 'custom_id_desc' || sortValue == 'custom_id'}">
          {{  "Custom ID" | translate }}
          <div class="d-f-c ml-1">
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('custom_id_desc')" [ngClass]="{'active': sortValue == 'custom_id_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('custom_id')" [ngClass]="{'active': sortValue == 'custom_id'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
          </div>
        </button>
        <button mat-menu-item (click)="sort(sortValue == 'internal_id_desc' ? 'internal_id' : 'internal_id_desc')" [ngClass]="{'active_status': sortValue == 'internal_id_desc' || sortValue == 'internal_id'}">
          {{  "Internal ID" | translate }}
          <div class="d-f-c ml-1">
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('internal_id_desc')" [ngClass]="{'active': sortValue == 'internal_id_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('internal_id')" [ngClass]="{'active': sortValue == 'internal_id'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
          </div>
        </button>
        <button mat-menu-item (click)="sort(sortValue == 'id_desc' ? 'id' : 'id_desc')" [ngClass]="{'active_status': sortValue == 'id_desc' || sortValue == 'id'}">
          {{  "ID" | translate }}
          <div class="d-f-c ml-1">
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('id_desc')" [ngClass]="{'active': sortValue == 'id_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('id')" [ngClass]="{'active': sortValue == 'id'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
          </div>
        </button>
        <button mat-menu-item (click)="sort(sortValue == 'filesize_desc' ? 'filesize' : 'filesize_desc')" [ngClass]="{'active_status': sortValue == 'filesize_desc' || sortValue == 'filesize'}">
          {{  "Filesize" | translate }}
          <div class="d-f-c ml-1">
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('filesize_desc')" [ngClass]="{'active': sortValue == 'filesize_desc'}" style="margin-right: 0 !important;">arrow_drop_down</mat-icon>
            <mat-icon (click)="$event.preventDefault(); $event.stopPropagation(); sort('filesize')" [ngClass]="{'active': sortValue == 'filesize'}" style="margin-right: 0 !important;">arrow_drop_up</mat-icon>
          </div>
        </button>
        <button mat-menu-item (click)="sort('score')" [ngClass]="{'active_status': sortValue == 'score'}" *ngIf="isES">
          {{  "Score" | translate }}
        </button>
      </mat-menu>
    </div>
  
    <div class="task_collections_wrp" *ngIf="taskCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))">
      <span>{{ "Actions with selected" | translate }}</span>
      <span>{{ taskCollection?.selected?.length }}</span>
      <span>{{ "card(s):" | translate }}</span>
  
      <div class="collections_btns">
        <button type="button" (click)="openTargetValues([0, 0, 0], null)">
          {{ "Add Tags" | translate }}
        </button>
        <button type="button" (click)="addChannels()">
          {{ "Add Outlets" | translate }}
        </button>
        <button type="button" *ngIf="cardsExpand && cardsExpand.jobs" [matMenuTriggerFor]="importMenu">
          {{ "Import files" | translate }}
        </button>
        <mat-menu #importMenu="matMenu" xPosition="after">
          <button mat-menu-item (click)="importFiles()" *ngIf="!!user?.is_root">
            <mat-icon>looks_one</mat-icon> 
            <span>{{ "Version" | translate }}</span>
          </button>
          <button (click)="importFilesV2()" mat-menu-item>
            <mat-icon>looks_two</mat-icon>
            <span>{{ "Version" | translate }}</span>
          </button>
        </mat-menu>
        <button type="button" (click)="multiEditTaskStatus()">
          {{ "Edit task type" | translate }}
        </button>
        <button type="button" (click)="addMultiWorks()">
          {{ "Add jobs" | translate }}
        </button>
        <button type="button" (click)="multiAddClients()">
          {{ "Add clients" | translate }}
        </button>
        <button type="button" (click)="multiEditGroups()">
          {{ "Edit Groups" | translate }}
        </button>
        <button type="button" (click)="addCardsScen()">
          {{ 'Set scenario' | translate }}
        </button>
        <button type="button" (click)="multiDeleteCards()" [disabled]="multiDeletedCards">
          {{ "Delete Cards" | translate }}
        </button>
      </div>
    </div>
  
  </div>
  
      <!-- <div *ngIf="is_mobile && showFilter" class="mobile_tasks_title_Wrp unselectable">
        <div class="mobile_filter_line">
          <div class="d-f-c">
            <button mat-raised-button [matMenuTriggerFor]="mobileStatusTab" class="mobActiveFilter">
              <ng-container [ngSwitch]="activeStatus">
                <ng-container *ngSwitchCase="'0'">
                  {{ "All" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'1'">
                  {{ "Waiting" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'2'">
                  {{ "In process" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'3'">
                  {{ "To approve" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'4'">
                  {{ "Approved" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'5'">
                  {{ "To correct" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'6'">
                  {{ "Sources needed" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'97'">
                  {{ "On hold" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'98'">
                  {{ "Ready" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'99'">
                  {{ "Canceled" | translate }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ "All" | translate }}
                </ng-container>
              </ng-container>
            </button>
            <mat-menu #mobileStatusTab="matMenu" class="mobileStatus" xPosition='after' [overlayPanelClass]='mobileStatusTab'>
              <button mat-menu-item  (click)='changeActiveStatus(0)' [ngClass]="{'active_status': activeStatus.includes(0)}">{{ "All" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(1)' [ngClass]="{'active_status': activeStatus.includes(1)}">{{ "Waiting" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(2)' [ngClass]="{'active_status': activeStatus.includes(2)}">{{ "In process" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(3)' [ngClass]="{'active_status': activeStatus.includes(3)}">{{ "To approve" | translate }}</button>
              <ng-container *ngIf="hasReminder; else elseTemplateHasReminderMob">
                <button mat-menu-item (click)='goToReminderCases()' [ngClass]="{'red': hasReminder}">
                    {{ "To Finalize" | translate }}
                  </button>
                  <button mat-menu-item (click)='changeActiveStatus(4, $event)' [ngClass]="{'active_status': activeStatus.includes(4) && activeStatus.length == 1}">
                    {{ "Approved" | translate }}
                  </button>
                </ng-container>
              <ng-template #elseTemplateHasReminderMob>
                <button mat-menu-item (click)='changeActiveStatus(4, $event)' [ngClass]="{'active_status': activeStatus.includes(4) && activeStatus.length == 1}">
                  {{ "Approved" | translate }}
                </button>
              </ng-template>
              <button mat-menu-item  (click)='changeActiveStatus(5)' [ngClass]="{'active_status': activeStatus.includes(5)}">{{ "To correct" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(6)' [ngClass]="{'active_status': activeStatus.includes(6)}">{{ "Sources needed" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(97)' [ngClass]="{'active_status': activeStatus.includes(97)}">{{ "On hold" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(98)' [ngClass]="{'active_status': activeStatus.includes(98)}">{{ "Ready" | translate }}</button>
              <button mat-menu-item  (click)='changeActiveStatus(99)' [ngClass]="{'active_status': activeStatus.includes(99)}">{{ "Canceled" | translate }}</button>
            </mat-menu>
            <button style="padding: 0 6px !important; min-width: auto !important;" class="ml-1" mat-raised-button (click)='openMobFilter()'>
              <mat-icon>filter_list</mat-icon>
            </button>

            <button [matMenuTriggerFor]="multiMenu" style="min-width: auto !important; padding: 0 6px !important;" class="ml-1" *ngIf="taskCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))" mat-raised-button color="warn">
              {{taskCollection?.selected?.length}}
              <mat-icon>settings</mat-icon>
            </button>
            <mat-menu #multiMenu="matMenu" xPosition="after">
              <button mat-menu-item (click)="multiEditTaskStatus()">
                <mat-icon>edit</mat-icon> 
                <span>{{ "Edit" | translate }} {{taskCollection?.selected?.length}} {{ 'task(s)' | translate }} {{ "statuses" | translate }}</span>
              </button>
              <button (click)="addMultiWorks()" mat-menu-item>
                <mat-icon>add</mat-icon>
                {{ "Add job to" | translate }} {{taskCollection?.selected?.length}} {{ 'task(s)' | translate }}
              </button>
            </mat-menu>
          </div>
          <mat-form-field [style.width]="taskCollection?.selected?.length ? '150px' : 'initial'" class="mobile_search">
            <input matInput #mobileSearch type="search" [value]="filter.get('q').value" placeholder="{{ 'Search' | translate}}" class="search-input">
            <mat-icon (click)="searchInMobile(mobileSearch)" matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="mobile_filter_wrp" #mobile_filter_wrp>
          <div class="d-f-c" style="justify-content: space-between;">
            <div class="d-f-c" style="display: inline-flex;">
              <button mat-button type="button" (click)="filterReset()">{{ "Reset" | translate }}</button>
              <button mat-raised-button type="button" class="ml-1" color="primary" (click)="filterTasks(null, null, true)">{{ "Filter" | translate }}</button>
            </div>
            <button mat-raised-button (click)='closeMobFilter()'>
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <form [formGroup]="filter" class="filter_wrp">
            <div class="mob_filter_inputs_wrp">
              <mat-form-field appearance="standard" class="filter_form">
                <mat-label>{{ 'Search' | translate }}</mat-label>
                <input formControlName="q" matInput placeholder="{{ 'Search' | translate }}">
              </mat-form-field>
            
              <mat-form-field appearance="standard" class="filter_form">
                <mat-label>{{ "By task status" | translate }}</mat-label>
                <mat-select formControlName="task_status_id">
                <mat-option *ngFor="let status of taskStatuses" [value]="status.id">
                    {{ status.name | translate }}
                </mat-option>
                </mat-select>
              </mat-form-field>
          
              <mat-form-field appearance="standard" class="filter_form">
                  <mat-label>{{ "By group" | translate }}</mat-label>
                  <mat-select formControlName="group_id">
                      <mat-option>
                        <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching group found' | translate }}"
                            [formControl]="groupsControl"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let group of groups$ | async" [value]="group.id">
                          {{ group.name | translate }}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          
              <mat-form-field appearance="standard" class="filter_form">
                <mat-label>{{ "By work status" | translate }}</mat-label>
                <mat-select formControlName="operation_status_id" multiple>
                <mat-option *ngFor="let status of operationStatuses" [value]="status.id">
                    {{ status.name | translate }}
                </mat-option>
                </mat-select>
              </mat-form-field>
          
          <mat-form-field appearance="legacy" class="filter_form">
            <mat-label>{{ "Executor" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" selectDir formControlName="operation_employee_id">
              <mat-option>
                <ngx-mat-select-search 
                    placeholderLabel="{{ 'Search' | translate }}" 
                    noEntriesFoundLabel="{{ 'no matching member found' | translate }}"
                    [formControl]="execControl"></ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="0">{{ "No executor" | translate }}</mat-option>
              <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                <app-user [class]="'user_div'" [employee]="employee"></app-user>
              </mat-option>
            </mat-select>
          </mat-form-field>
          
          <mat-form-field appearance="legacy" class="filter_form">
            <mat-label>{{ "Client" | translate }}</mat-label>
            <mat-select [disableOptionCentering]="true" selectDir formControlName="client_employee_id">
              <mat-option>
                <ngx-mat-select-search 
                    placeholderLabel="{{ 'Search' | translate }}" 
                    noEntriesFoundLabel="{{ 'no matching member found' | translate }}"
                    [formControl]="clientControl"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                <app-user [class]="'user_div'" [employee]="employee"></app-user>
              </mat-option>
            </mat-select>
          </mat-form-field>
          
              <mat-form-field appearance="standard" class="filter_form">
                <mat-label>{{ "By profile" | translate }}</mat-label>
                <mat-select #profilesContainer formControlName="channel_id">
                  <mat-option>
                    <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching outlet found' | translate }}"
                        [formControl]="profilesMoreControl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="0">
                    {{ "All profiles" | translate }}
                  </mat-option>
                  <mat-option *ngFor="let profile of profiles$ | async" [value]="profile.id">
                    <div class="platform_wrp">
                      <div [ngSwitch]="profile?.platform_id">
                          <ng-container *ngSwitchCase="1">
                              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#FF0000"/>
                                  <path d="M36.265 18.0732C35.9706 16.9422 35.1031 16.0516 34.0016 15.7493C32.0054 15.2 24 15.2 24 15.2C24 15.2 15.9946 15.2 13.9983 15.7493C12.8967 16.0516 12.0292 16.9422 11.7348 18.0732C11.2 20.123 11.2 24.4 11.2 24.4C11.2 24.4 11.2 28.6768 11.7348 30.7268C12.0292 31.8578 12.8967 32.7484 13.9983 33.0508C15.9946 33.6 24 33.6 24 33.6C24 33.6 32.0054 33.6 34.0016 33.0508C35.1031 32.7484 35.9706 31.8578 36.265 30.7268C36.8 28.6768 36.8 24.4 36.8 24.4C36.8 24.4 36.8 20.123 36.265 18.0732Z" fill="white"/>
                                  <path d="M21.6 28.8V20.8L28 24.8002L21.6 28.8Z" fill="#FF0000"/>
                              </svg>
                          </ng-container>
                          <ng-container *ngSwitchCase="2">
                              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="3" y="3" width="42" height="42" rx="6" fill="url(#paint0_radial_33_590)"/>
                                  <rect x="3" y="3" width="42" height="42" rx="6" fill="url(#paint1_radial_33_590)"/>
                                  <rect x="3" y="3" width="42" height="42" rx="6" fill="url(#paint2_radial_33_590)"/>
                                  <path d="M34.5 15.75C34.5 16.9926 33.4926 18 32.25 18C31.0074 18 30 16.9926 30 15.75C30 14.5074 31.0074 13.5 32.25 13.5C33.4926 13.5 34.5 14.5074 34.5 15.75Z" fill="white"/>
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 31.5C28.1421 31.5 31.5 28.1421 31.5 24C31.5 19.8579 28.1421 16.5 24 16.5C19.8579 16.5 16.5 19.8579 16.5 24C16.5 28.1421 19.8579 31.5 24 31.5ZM24 28.5C26.4853 28.5 28.5 26.4853 28.5 24C28.5 21.5147 26.4853 19.5 24 19.5C21.5147 19.5 19.5 21.5147 19.5 24C19.5 26.4853 21.5147 28.5 24 28.5Z" fill="white"/>
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 23.4C9 18.3595 9 15.8393 9.98094 13.9141C10.8438 12.2206 12.2206 10.8438 13.9141 9.98094C15.8393 9 18.3595 9 23.4 9H24.6C29.6405 9 32.1607 9 34.0859 9.98094C35.7794 10.8438 37.1562 12.2206 38.0191 13.9141C39 15.8393 39 18.3595 39 23.4V24.6C39 29.6405 39 32.1607 38.0191 34.0859C37.1562 35.7794 35.7794 37.1562 34.0859 38.0191C32.1607 39 29.6405 39 24.6 39H23.4C18.3595 39 15.8393 39 13.9141 38.0191C12.2206 37.1562 10.8438 35.7794 9.98094 34.0859C9 32.1607 9 29.6405 9 24.6V23.4ZM23.4 12H24.6C27.1697 12 28.9166 12.0023 30.2669 12.1127C31.5821 12.2201 32.2547 12.4149 32.7239 12.654C33.8529 13.2292 34.7708 14.1471 35.346 15.2761C35.5851 15.7453 35.7799 16.4179 35.8873 17.7331C35.9977 19.0834 36 20.8303 36 23.4V24.6C36 27.1697 35.9977 28.9166 35.8873 30.2669C35.7799 31.5821 35.5851 32.2547 35.346 32.7239C34.7708 33.8529 33.8529 34.7708 32.7239 35.346C32.2547 35.5851 31.5821 35.7799 30.2669 35.8873C28.9166 35.9977 27.1697 36 24.6 36H23.4C20.8303 36 19.0834 35.9977 17.7331 35.8873C16.4179 35.7799 15.7453 35.5851 15.2761 35.346C14.1471 34.7708 13.2292 33.8529 12.654 32.7239C12.4149 32.2547 12.2201 31.5821 12.1127 30.2669C12.0023 28.9166 12 27.1697 12 24.6V23.4C12 20.8303 12.0023 19.0834 12.1127 17.7331C12.2201 16.4179 12.4149 15.7453 12.654 15.2761C13.2292 14.1471 14.1471 13.2292 15.2761 12.654C15.7453 12.4149 16.4179 12.2201 17.7331 12.1127C19.0834 12.0023 20.8303 12 23.4 12Z" fill="white"/>
                                  <defs>
                                  <radialGradient id="paint0_radial_33_590" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(18 34.5) rotate(-55.3758) scale(38.2794)">
                                  <stop stop-color="#B13589"/>
                                  <stop offset="0.79309" stop-color="#C62F94"/>
                                  <stop offset="1" stop-color="#8A3AC8"/>
                                  </radialGradient>
                                  <radialGradient id="paint1_radial_33_590" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.5 46.5) rotate(-65.1363) scale(33.8914)">
                                  <stop stop-color="#E0E8B7"/>
                                  <stop offset="0.444662" stop-color="#FB8A2E"/>
                                  <stop offset="0.71474" stop-color="#E2425C"/>
                                  <stop offset="1" stop-color="#E2425C" stop-opacity="0"/>
                                  </radialGradient>
                                  <radialGradient id="paint2_radial_33_590" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0.750002 4.5) rotate(-8.1301) scale(58.3363 12.4775)">
                                  <stop offset="0.156701" stop-color="#406ADC"/>
                                  <stop offset="0.467799" stop-color="#6A45BE"/>
                                  <stop offset="1" stop-color="#6A45BE" stop-opacity="0"/>
                                  </radialGradient>
                                  </defs>
                              </svg>
                          </ng-container>
                          <ng-container *ngSwitchCase="3">
                              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M34.353 17.327C37.4397 19.5413 41.2211 20.8442 45.3051 20.8442V12.9573C44.5322 12.9574 43.7613 12.8765 43.0051 12.7158V18.9239C38.9214 18.9239 35.1405 17.621 32.053 15.4068V31.5018C32.053 39.5533 25.5492 46.0799 17.5268 46.0799C14.5334 46.0799 11.7512 45.1717 9.44006 43.6141C12.0779 46.3209 15.7565 48 19.8263 48C27.8492 48 34.3534 41.4734 34.3534 33.4216V17.327H34.353ZM37.1904 9.37002C35.6129 7.64048 34.5772 5.40538 34.353 2.93438V1.91995H32.1735C32.7221 5.06059 34.5934 7.74377 37.1904 9.37002ZM14.5142 37.4356C13.6329 36.2759 13.1566 34.8572 13.1587 33.3985C13.1587 29.7161 16.1336 26.7303 19.8037 26.7303C20.4877 26.7301 21.1675 26.8352 21.8194 27.0428V18.9796C21.0576 18.8748 20.2888 18.8303 19.5203 18.8466V25.1226C18.868 24.9151 18.1878 24.8096 17.5037 24.8103C13.8335 24.8103 10.8589 27.7958 10.8589 31.4787C10.8589 34.0828 12.3458 36.3374 14.5142 37.4356Z" fill="#FF004F"/>
                                  <path d="M32.0529 15.4067C35.1404 17.6209 38.9213 18.9237 43.005 18.9237V12.7156C40.7255 12.2283 38.7075 11.0328 37.1903 9.37002C34.5931 7.74361 32.722 5.06043 32.1733 1.91995H26.4482V33.4213C26.4352 37.0937 23.4655 40.0673 19.8032 40.0673C17.6451 40.0673 15.7279 39.0349 14.5136 37.4356C12.3454 36.3374 10.8585 34.0827 10.8585 31.4789C10.8585 27.7963 13.8331 24.8105 17.5032 24.8105C18.2064 24.8105 18.8842 24.9204 19.5199 25.1228V18.8468C11.6384 19.0102 5.2998 25.473 5.2998 33.4214C5.2998 37.3892 6.87827 40.9861 9.44013 43.6143C11.7513 45.1717 14.5335 46.08 17.5268 46.08C25.5494 46.08 32.0531 39.5531 32.0531 31.5018V15.4067H32.0529Z" fill="black"/>
                                  <path d="M43.0051 12.7156V11.037C40.9495 11.0401 38.9343 10.4624 37.1903 9.36987C38.7342 11.0661 40.7671 12.2357 43.0051 12.7156ZM32.1734 1.91997C32.1211 1.61982 32.0809 1.3177 32.053 1.01443V0H24.148V31.5016C24.1354 35.1735 21.1658 38.1471 17.5033 38.1471C16.428 38.1471 15.4128 37.891 14.5137 37.4358C15.7279 39.0349 17.6452 40.0671 19.8033 40.0671C23.4652 40.0671 26.4354 37.0938 26.4482 33.4214V1.91997H32.1734ZM19.5203 18.8468V17.0598C18.8598 16.9692 18.1938 16.9237 17.5271 16.924C9.50383 16.9239 3 23.4508 3 31.5016C3 36.5491 5.55612 40.9974 9.44034 43.614C6.87848 40.986 5.30002 37.3889 5.30002 33.4213C5.30002 25.473 11.6385 19.0102 19.5203 18.8468Z" fill="#00F2EA"/>
                              </svg>   
                          </ng-container>
                          <ng-container *ngSwitchCase="4">
                              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 35.9789 8.77641 45.908 20.25 47.7084V30.9375H14.1562V24H20.25V18.7125C20.25 12.6975 23.8331 9.375 29.3152 9.375C31.9402 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6613C28.68 15.75 27.75 17.6002 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7084C39.2236 45.908 48 35.9789 48 24Z" fill="#1877F2"/>
                                  <path d="M33.3422 30.9375L34.4062 24H27.75V19.5C27.75 17.602 28.68 15.75 31.6613 15.75H34.6875V9.84375C34.6875 9.84375 31.9411 9.375 29.3152 9.375C23.8331 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7084C22.7349 48.0972 25.2651 48.0972 27.75 47.7084V30.9375H33.3422Z" fill="white"/>
                              </svg>
                          </ng-container>
                          <ng-container *ngSwitchCase="5">
                              <svg height="512pt" class="without_back" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m502 256c0 135.863281-110.136719 246-246 246s-246-110.136719-246-246 110.136719-246 246-246 246 110.136719 246 246zm0 0" fill="#f7e300" fill-rule="evenodd"/><path d="m138.140625 209.71875c-25.074219-7.546875-35.332031 27.652344-11.050781 36.695312l25.054687 9.332032c0 32.605468-29.347656 54.019531-51.707031 62.535156-10.472656 3.285156-18.71875 8.496094-18.828125 16.6875-.125 9.390625 10.554687 21.800781 42.8125 24.539062 2.445313 43.3125 44.222656 19.339844 64.636719 26.492188 25.394531 8.898438 44.535156 30.550781 66.941406 30.550781 22.402344 0 41.546875-21.652343 66.9375-30.550781 20.414062-7.152344 62.195312 16.820312 64.640625-26.492188 32.257813-2.738281 42.933594-15.148437 42.808594-24.539062-.109375-8.191406-8.355469-13.402344-18.824219-16.6875-22.359375-8.515625-51.710938-29.929688-51.710938-62.535156l25.054688-9.332032c24.28125-9.042968 14.027344-44.242187-11.046875-36.695312l-13.898437 4.1875-1.898438-36.390625c0-56.371094-45.695312-102.066406-102.0625-102.066406-56.371094 0-102.066406 45.695312-102.066406 102.066406l-1.894532 36.390625zm0 0" fill="#fff" fill-rule="evenodd"/><path d="m414.859375 308.835938c-19.003906-7.308594-40.804687-23.488282-44.46875-46.34375l18.007813-6.707032c18.167968-6.765625 23.21875-24.539062 18.75-37.828125-4.355469-12.953125-18.179688-23.230469-36.171876-17.8125l-1.695312.507813-1.21875-23.40625c-.144531-61.667969-50.359375-111.796875-112.0625-111.796875s-111.917969 50.128906-112.0625 111.796875l-1.21875 23.410156-1.695312-.511719c-17.988282-5.414062-31.816407 4.863281-36.171876 17.8125-4.46875 13.289063.582032 31.0625 18.75 37.828125l18.011719 6.707032c-3.667969 22.859374-25.46875 39.035156-44.472656 46.34375-20.890625 6.648437-25.417969 17.800781-25.527344 26-.179687 13.523437 11.433594 28.902343 43.84375 33.699218 1.6875 8.683594 5.238281 15.273438 10.761719 20.007813 11.222656 9.628906 26.582031 8.144531 40.132812 6.835937 7.410157-.71875 15.070313-1.457031 19.402344.058594 9.441406 3.308594 18.339844 8.832031 26.941406 14.171875 13.417969 8.328125 27.292969 16.941406 43.304688 16.941406s29.886719-8.613281 43.304688-16.941406c8.605468-5.339844 17.5-10.863281 26.941406-14.171875 4.332031-1.515625 11.996094-.777344 19.402344-.058594 13.554687 1.308594 28.914062 2.792969 40.132812-6.835937 5.523438-4.734375 9.078125-11.324219 10.761719-20.007813 32.410156-4.796875 44.023437-20.175781 43.847656-33.695312-.113281-8.207032-4.636719-19.355469-25.53125-26.003906zm-28.128906 40.707031c-4.960938.421875-8.855469 4.429687-9.136719 9.402343-.40625 7.160157-2.03125 12.011719-4.832031 14.417969-4.757813 4.078125-15.144531 3.074219-25.191407 2.105469-9.5625-.925781-19.453124-1.878906-27.9375 1.09375-11.515624 4.03125-21.359374 10.144531-30.878906 16.050781-12.042968 7.480469-22.445312 13.9375-32.753906 13.9375s-20.710938-6.457031-32.757812-13.9375c-9.519532-5.90625-19.363282-12.019531-30.875-16.050781-4.320313-1.515625-9.003907-2.011719-13.820313-2.011719-4.648437 0-9.425781.460938-14.121094.917969-10.042969.96875-20.429687 1.972656-25.1875-2.105469-2.800781-2.40625-4.429687-7.257812-4.832031-14.417969-.28125-4.972656-4.175781-8.980468-9.136719-9.402343-25.550781-2.171875-33.710937-10.667969-33.660156-14.441407.023437-1.726562 3.730469-4.742187 11.820313-7.28125.191406-.058593.378906-.125.566406-.195312 26.824218-10.214844 58.148437-35.167969 58.148437-71.878906 0-4.179688-2.59375-7.914063-6.507812-9.371094l-25.058594-9.332031c-7.246094-2.699219-8.175781-8.535157-6.773437-12.710938.78125-2.316406 3.457031-7.445312 11.453124-5.035156l13.898438 4.183594c2.941406.886719 6.125.371093 8.636719-1.394531 2.511719-1.769532 4.070312-4.59375 4.230469-7.660157l1.898437-36.390625c.007813-.171875.011719-.347656.011719-.519531 0-50.765625 41.300781-92.066406 92.066406-92.066406s92.0625 41.300781 92.0625 92.066406c0 .171875.007812.34375.015625.519531l1.894531 36.390625c.160156 3.066407 1.722656 5.890625 4.230469 7.65625 2.515625 1.769531 5.695313 2.285157 8.640625 1.398438l13.898438-4.183594c8-2.410156 10.671874 2.71875 11.449218 5.035156 1.40625 4.175781.472656 10.011719-6.773437 12.710938l-25.054688 9.328125c-3.914062 1.460937-6.507812 5.195312-6.507812 9.371094 0 36.714843 31.324219 61.667968 58.148437 71.882812.1875.070312.375.136719.5625.195312 8.089844 2.539063 11.796875 5.550782 11.820313 7.28125.050781 3.777344-8.109375 12.273438-33.65625 14.441407zm0 0"/><path d="m393.519531 447.800781c-40.25 28.914063-87.800781 44.199219-137.519531 44.199219-130.128906 0-236-105.867188-236-236 0-49.71875 15.28125-97.269531 44.195312-137.519531 3.222657-4.484375 2.199219-10.734375-2.285156-13.953125-4.484375-3.222656-10.734375-2.199219-13.957031 2.285156-31.371094 43.667969-47.953125 95.257812-47.953125 149.1875 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.640625 74.980469 181.019531 74.980469 53.929688 0 105.519531-16.582031 149.1875-47.957031 4.488281-3.222657 5.511719-9.46875 2.289062-13.953125-3.222656-4.488282-9.46875-5.511719-13.957031-2.289063zm0 0"/><path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-53.925781 0-105.515625 16.582031-149.191406 47.957031-4.484375 3.222657-5.507813 9.472657-2.289063 13.957031 3.222657 4.484376 9.472657 5.511719 13.957031 2.289063 40.253907-28.917969 87.808594-44.203125 137.523438-44.203125 130.132812 0 236 105.871094 236 236 0 49.710938-15.285156 97.265625-44.199219 137.519531-3.222656 4.488281-2.195312 10.734375 2.289063 13.957031 1.765625 1.269532 3.804687 1.878907 5.824218 1.878907 3.109376 0 6.179688-1.449219 8.132813-4.167969 31.371094-43.675781 47.953125-95.261719 47.953125-149.1875 0-68.378906-26.628906-132.667969-74.980469-181.019531zm0 0"/><path d="m82.046875 92.054688c2.5625 0 5.125-.980469 7.074219-2.933594 3.90625-3.902344 3.90625-10.234375 0-14.140625-3.902344-3.90625-10.234375-3.90625-14.140625 0l-.003907.003906c-3.90625 3.90625-3.902343 10.234375 0 14.140625 1.953126 1.953125 4.511719 2.929688 7.070313 2.929688zm0 0"/><path d="m422.550781 423.21875-.003906.003906c-3.714844 4.085938-3.410156 10.410156.675781 14.125 1.914063 1.742188 4.320313 2.597656 6.722656 2.597656 2.71875 0 5.433594-1.101562 7.40625-3.273437 3.714844-4.085937 3.414063-10.410156-.675781-14.125-4.085937-3.714844-10.410156-3.414063-14.125.671875zm0 0"/></svg>
                          </ng-container>
                          <ng-container *ngSwitchCase="6">
                              <svg class="without_back"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                  viewBox="0 0 112.196 112.196" style="enable-background:new 0 0 112.196 112.196;" xml:space="preserve">
                              <g>
                                  <g>
                                  <circle id="XMLID_11_" style="fill:#4D76A1;" cx="56.098" cy="56.098" r="56.098"/>
                                  </g>
                                  <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" d="M53.979,80.702h4.403c0,0,1.33-0.146,2.009-0.878
                                  c0.625-0.672,0.605-1.934,0.605-1.934s-0.086-5.908,2.656-6.778c2.703-0.857,6.174,5.71,9.853,8.235
                                  c2.782,1.911,4.896,1.492,4.896,1.492l9.837-0.137c0,0,5.146-0.317,2.706-4.363c-0.2-0.331-1.421-2.993-7.314-8.463
                                  c-6.168-5.725-5.342-4.799,2.088-14.702c4.525-6.031,6.334-9.713,5.769-11.29c-0.539-1.502-3.867-1.105-3.867-1.105l-11.076,0.069
                                  c0,0-0.821-0.112-1.43,0.252c-0.595,0.357-0.978,1.189-0.978,1.189s-1.753,4.667-4.091,8.636c-4.932,8.375-6.904,8.817-7.71,8.297
                                  c-1.875-1.212-1.407-4.869-1.407-7.467c0-8.116,1.231-11.5-2.397-12.376c-1.204-0.291-2.09-0.483-5.169-0.514
                                  c-3.952-0.041-7.297,0.012-9.191,0.94c-1.26,0.617-2.232,1.992-1.64,2.071c0.732,0.098,2.39,0.447,3.269,1.644
                                  c1.135,1.544,1.095,5.012,1.095,5.012s0.652,9.554-1.523,10.741c-1.493,0.814-3.541-0.848-7.938-8.446
                                  c-2.253-3.892-3.954-8.194-3.954-8.194s-0.328-0.804-0.913-1.234c-0.71-0.521-1.702-0.687-1.702-0.687l-10.525,0.069
                                  c0,0-1.58,0.044-2.16,0.731c-0.516,0.611-0.041,1.875-0.041,1.875s8.24,19.278,17.57,28.993
                                  C44.264,81.287,53.979,80.702,53.979,80.702L53.979,80.702z"/>
                              </g>
                              </svg>
                          </ng-container>
                          <ng-container *ngSwitchCase="7">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                <path style="fill:#889391;" d="M507.242,206.72C484.267,88.918,380.526,0,256,0C114.616,0,0,114.616,0,256
                                    c0,121.266,84.321,222.832,197.527,249.284L507.242,206.72z"/>
                                <path style="fill:#616F6D;" d="M395.13,161.391l-55.652-55.652L96.557,404.313l100.971,100.971C216.309,509.673,235.882,512,256,512
                                    c141.385,0,256-114.616,256-256c0-16.858-1.647-33.331-4.758-49.28L428.522,128L395.13,161.391z"/>
                                <polygon style="fill:#FEF2CC;" points="339.478,128 384,417.391 211.478,417.391 166.957,261.565 211.478,105.739 339.478,105.739 
                                    "/>
                                <path style="fill:#FFFFFF;" d="M211.478,105.739v222.609l-11.13,11.13l11.13,11.13v22.261L200.348,384l11.13,11.13v22.261H128
                                    c-24.487,0-44.522-20.035-44.522-44.522v-267.13H211.478z"/>
                                <path style="fill:#F9BE02;" d="M384,128l-22.261,144.696L384,417.391c24.487,0,44.522-20.035,44.522-44.522V128H384z"/>
                                <polygon style="fill:#F63341;" points="211.478,128 185.76,172.522 211.478,217.043 317.217,217.043 317.217,128 "/>
                                <rect x="105.739" y="128" style="fill:#F85C67;" width="105.739" height="89.043"/>
                                <polygon style="fill:#616F6D;" points="211.478,239.304 185.76,250.435 211.478,261.565 317.217,261.565 317.217,239.304 "/>
                                <rect x="105.739" y="239.304" style="fill:#889391;" width="105.739" height="22.261"/>
                                <polygon style="fill:#616F6D;" points="211.478,283.826 185.76,294.957 211.478,306.087 317.217,306.087 317.217,283.826 "/>
                                <g>
                                    <rect x="105.739" y="283.826" style="fill:#889391;" width="105.739" height="22.261"/>
                                    <rect x="105.739" y="328.348" style="fill:#889391;" width="105.739" height="22.261"/>
                                </g>
                                <rect x="159.165" y="372.87" style="fill:#FBD867;" width="52.313" height="22.261"/>
                                <rect x="233.739" y="328.348" style="fill:#F63341;" width="83.478" height="66.783"/>
                                <path style="fill:#FBD867;" d="M339.478,128v244.87c0,24.487,20.035,44.522,44.522,44.522V128H339.478z"/>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="8">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                <circle style="fill:#88C5CC;" cx="256" cy="256" r="256"/>
                                <path style="fill:#CCCCCC;" d="M100,396c-15.436,0-28-12.564-28-28V140c0-15.436,8.564-24,24-24h316c15.436,0,28,12.564,28,28v224
                                    c0,15.436-12.564,28-28,28H100z"/>
                                <circle style="fill:#CC584C;" cx="95.812" cy="140" r="8"/>
                                <circle style="fill:#FFD464;" cx="119.812" cy="140" r="8"/>
                                <circle style="fill:#198058;" cx="143.812" cy="140" r="8"/>
                                <g>
                                    <path style="fill:#F5F5F5;" d="M403.812,144c0,2.2-1.8,4-4,4h-232c-2.2,0-4-1.8-4-4v-8c0-2.2,1.8-4,4-4h232c2.2,0,4,1.8,4,4V144z"
                                        />
                                    <path style="fill:#F5F5F5;" d="M424,372c0,4.4-3.6,8-8,8H96c-4.4,0-8-3.6-8-8V172c0-4.4,3.6-8,8-8h320c4.4,0,8,3.6,8,8V372z"/>
                                </g>
                                <g>
                                    <path style="fill:#406A80;" d="M160,356c0,4.4-3.6,8-8,8h-40c-4.4,0-8-3.6-8-8V188c0-4.4,3.6-8,8-8h40c4.4,0,8,3.6,8,8V356z"/>
                                    <path style="fill:#406A80;" d="M400,180c4.4,0,8,3.6,8,8v40c0,4.408-3.6,8-8,8H184c-4.4,0-8-3.592-8-8v-40c0-4.4,3.6-8,8-8H400z"/>
                                </g>
                                <g>
                                    <rect x="176" y="248" style="fill:#B3B3B3;" width="232" height="8"/>
                                    <rect x="176" y="260" style="fill:#B3B3B3;" width="232" height="8"/>
                                    <rect x="176" y="272" style="fill:#B3B3B3;" width="232" height="8"/>
                                    <rect x="176" y="284" style="fill:#B3B3B3;" width="52" height="52"/>
                                </g>
                                <rect x="236" y="284" style="fill:#E16B5A;" width="52" height="52"/>
                                <g>
                                    <rect x="296" y="284" style="fill:#B3B3B3;" width="52" height="52"/>
                                    <rect x="356" y="284" style="fill:#B3B3B3;" width="52" height="52"/>
                                </g>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="9">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                <circle style="fill:#7AA5DA;" cx="256" cy="256" r="256"/>
                                <path style="fill:#5786B5;" d="M511.924,250.077L398.283,136.625l-185.108,225.63l133.284,133.284
                                    C443.197,458.988,512,365.535,512,256C512,254.019,511.969,252.045,511.924,250.077z"/>
                                <path style="fill:#FFFFFF;" d="M383.717,133.52c10.206-3.982,20.756,4.948,18.515,15.67l-45.77,218.781
                                    c-2.138,10.257-14.188,14.877-22.635,8.671l-69.094-50.717l-35.219,35.961c-6.189,6.31-16.86,3.741-19.515-4.672l-25.41-80.662
                                    l-68.112-20.118c-8.947-2.638-9.464-15.084-0.793-18.48L383.717,133.52z M350.118,182.065c2.982-2.638-0.483-7.292-3.862-5.189
                                    l-147.015,91.177c-2.586,1.603-3.775,4.758-2.862,7.671l20.049,88.04c0.397,1.345,2.327,1.155,2.5-0.241l4.482-67.094
                                    c0.172-1.655,0.965-3.172,2.207-4.275L350.118,182.065z"/>
                                <path style="fill:#9EC2E5;" d="M346.257,176.876c3.379-2.103,6.844,2.551,3.862,5.189l-124.5,110.089
                                    c-1.241,1.103-2.034,2.62-2.207,4.275l-4.482,67.094c-0.172,1.396-2.103,1.586-2.5,0.241l-20.049-88.04
                                    c-0.914-2.913,0.276-6.068,2.862-7.671L346.257,176.876z"/>
                                <path style="fill:#FFFFFF;" d="M217.154,364.678c-3.241-1.155-5.982-3.741-7.154-7.465l-25.41-80.662l-68.112-20.118
                                    c-8.947-2.638-9.464-15.084-0.793-18.48L383.717,133.52c6.585-2.569,13.326,0.241,16.653,5.448
                                    c-0.621-0.948-1.362-1.827-2.189-2.603L216.343,284.81v6.499l-1-0.724l1,40.926v32.823c0.259,0.121,0.534,0.224,0.81,0.31V364.678
                                    L217.154,364.678z"/>
                                <g>
                                    <path style="fill:#D1D1D1;" d="M402.525,145.518c0.052,1.172-0.034,2.413-0.293,3.672l-45.77,218.781
                                        c-2.138,10.257-14.188,14.877-22.635,8.671l-69.094-50.717l-48.39-34.616v-6.499l181.838-148.446
                                        c0.827,0.776,1.569,1.655,2.189,2.603c0.121,0.207,0.241,0.396,0.362,0.586c0.103,0.207,0.224,0.414,0.328,0.603
                                        c0.103,0.207,0.207,0.414,0.293,0.621c0.103,0.224,0.19,0.431,0.276,0.655c0.069,0.19,0.155,0.396,0.224,0.621
                                        c0.224,0.672,0.396,1.362,0.517,2.086C402.439,144.587,402.491,145.036,402.525,145.518z"/>
                                    <path style="fill:#D1D1D1;" d="M264.733,325.925l-35.219,35.961c-0.293,0.293-0.603,0.586-0.914,0.845
                                        c-0.31,0.259-0.621,0.483-0.948,0.707c-0.017,0.017-0.017,0.017-0.017,0.017c-0.655,0.431-1.327,0.793-2.034,1.086
                                        c-0.362,0.138-0.707,0.276-1.069,0.362c-1.5,0.448-3.034,0.569-4.551,0.414c-0.396-0.034-0.793-0.103-1.172-0.172
                                        c-0.052,0-0.103-0.017-0.155-0.034c-0.379-0.103-0.759-0.207-1.138-0.328c-0.121-0.034-0.241-0.069-0.362-0.138l-0.81-33.133
                                        v-40.202L264.733,325.925z"/>
                                </g>
                                <g>
                                    <path style="fill:#DADDE0;" d="M228.6,362.73c-0.31,0.259-0.621,0.5-0.948,0.724v-0.017
                                        C227.98,363.213,228.29,362.989,228.6,362.73z"/>
                                    <path style="fill:#DADDE0;" d="M227.652,363.437v0.017c0,0,0-0.017-0.017,0C227.635,363.454,227.635,363.454,227.652,363.437z"/>
                                    <path style="fill:#DADDE0;" d="M225.601,364.541c0.707-0.293,1.379-0.655,2.034-1.086
                                        C226.98,363.885,226.29,364.247,225.601,364.541z"/>
                                    <path style="fill:#DADDE0;" d="M219.981,365.316c1.517,0.155,3.051,0.034,4.551-0.414c-1.086,0.345-2.207,0.5-3.327,0.5
                                        c-0.345,0-0.69-0.017-1.017-0.052C220.119,365.351,220.05,365.351,219.981,365.316z"/>
                                </g>
                                <g>
                                    <path style="fill:#FFFFFF;" d="M221.205,365.402c-0.345,0-0.69-0.017-1.017-0.052C220.515,365.385,220.86,365.402,221.205,365.402z
                                        "/>
                                    <path style="fill:#FFFFFF;" d="M219.981,365.316c0.069,0.034,0.138,0.034,0.207,0.034c-0.362-0.017-0.69-0.069-1.034-0.138
                                        C219.429,365.265,219.705,365.299,219.981,365.316z"/>
                                </g>
                                <g>
                                    <path style="fill:#DADDE0;" d="M219.981,365.316c-0.276-0.017-0.552-0.052-0.827-0.103c-0.121-0.017-0.241-0.034-0.345-0.069
                                        C219.188,365.213,219.584,365.282,219.981,365.316z"/>
                                    <path style="fill:#DADDE0;" d="M217.516,364.782c0.379,0.121,0.759,0.224,1.138,0.328c-0.155-0.034-0.31-0.069-0.465-0.103
                                        c-0.069-0.017-0.138-0.034-0.19-0.069C217.843,364.903,217.671,364.851,217.516,364.782z"/>
                                </g>
                                <g>
                                    <path style="fill:#FFFFFF;" d="M218.188,365.006c0.155,0.034,0.31,0.069,0.465,0.103
                                        C218.498,365.092,218.343,365.058,218.188,365.006z"/>
                                    <path style="fill:#FFFFFF;" d="M217.516,364.782c0.155,0.069,0.328,0.121,0.483,0.155c-0.259-0.052-0.517-0.138-0.776-0.241
                                        C217.326,364.73,217.412,364.765,217.516,364.782z"/>
                                </g>
                                <path style="fill:#DADDE0;" d="M217.516,364.782c-0.103-0.017-0.19-0.052-0.293-0.086c-0.017,0.017-0.052,0-0.069-0.017v-0.034
                                    C217.274,364.713,217.395,364.747,217.516,364.782z"/>
                                <path style="fill:#D1D1D1;" d="M216.343,331.511l0.81,33.133c-0.276-0.086-0.552-0.19-0.81-0.31V331.511z"/>
                                <polygon style="fill:#DADDE0;" points="216.343,291.309 216.343,331.511 215.343,290.585 "/>
                                <path style="fill:#ADBCC9;" d="M350.118,182.065l-124.5,110.089c-1.241,1.103-2.034,2.62-2.207,4.275l-4.474,67.1
                                    c-0.172,1.396-2.103,1.586-2.517,0.241l-20.04-88.045c-0.914-2.913,0.276-6.068,2.862-7.671l147.015-91.177
                                    C349.636,174.773,353.101,179.428,350.118,182.065z"/>
                            </svg>

                        </ng-container>
                        <ng-container *ngSwitchCase="10">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 291.319 291.319" style="enable-background:new 0 0 291.319 291.319;" xml:space="preserve">
                                <g>
                                    <path style="fill:#86C9EF;" d="M145.659,0c80.45,0,145.66,65.219,145.66,145.66c0,80.45-65.21,145.659-145.66,145.659
                                        S0,226.109,0,145.66C0,65.219,65.21,0,145.659,0z"/>
                                    <path style="fill:#FFFFFF;" d="M63.726,118.348c13.619-10.87,32.983-34.74,48.086-34.74c15.085,0,18.79,17.816,20.848,33.975
                                        c2.085,16.159,8.011,51.509,15.986,51.509c7.993,0,26.191-31.271,25.154-43.352c-1.02-12.081-14.202-10.269-21.448-6.8
                                        c6.664-24.161,22.049-37.007,41.722-37.007c19.682,0,24.425,13.901,24.425,30.971c0,25.982-52.665,105.585-84.483,105.585
                                        c-19.682,0-24.562-29.004-28.549-43.361c-3.997-14.338-11.844-51.964-21.02-54.377c-3.56-0.592-13.61,7.392-13.61,7.392
                                        L63.726,118.348z"/>
                                </g>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="11">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 112.197 112.197" style="enable-background:new 0 0 112.197 112.197;" xml:space="preserve">
                                <g>
                                    <circle style="fill:#55ACEE;" cx="56.099" cy="56.098" r="56.098"/>
                                    <g>
                                        <path style="fill:#F1F2F2;" d="M90.461,40.316c-2.404,1.066-4.99,1.787-7.702,2.109c2.769-1.659,4.894-4.284,5.897-7.417
                                            c-2.591,1.537-5.462,2.652-8.515,3.253c-2.446-2.605-5.931-4.233-9.79-4.233c-7.404,0-13.409,6.005-13.409,13.409
                                            c0,1.051,0.119,2.074,0.349,3.056c-11.144-0.559-21.025-5.897-27.639-14.012c-1.154,1.98-1.816,4.285-1.816,6.742
                                            c0,4.651,2.369,8.757,5.965,11.161c-2.197-0.069-4.266-0.672-6.073-1.679c-0.001,0.057-0.001,0.114-0.001,0.17
                                            c0,6.497,4.624,11.916,10.757,13.147c-1.124,0.308-2.311,0.471-3.532,0.471c-0.866,0-1.705-0.083-2.523-0.239
                                            c1.706,5.326,6.657,9.203,12.526,9.312c-4.59,3.597-10.371,5.74-16.655,5.74c-1.08,0-2.15-0.063-3.197-0.188
                                            c5.931,3.806,12.981,6.025,20.553,6.025c24.664,0,38.152-20.432,38.152-38.153c0-0.581-0.013-1.16-0.039-1.734
                                            C86.391,45.366,88.664,43.005,90.461,40.316L90.461,40.316z"/>
                                    </g>
                                </g>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="12">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 291.319 291.319" style="enable-background:new 0 0 291.319 291.319;" xml:space="preserve">
                                <g>
                                    <path style="fill:#C8232C;" d="M145.659,0c80.45,0,145.66,65.219,145.66,145.66c0,80.45-65.21,145.659-145.66,145.659
                                        S0,226.109,0,145.66C0,65.219,65.21,0,145.659,0z"/>
                                    <path style="fill:#FFFFFF;" d="M150.066,63.781c-51.327,0-77.19,35.632-77.19,65.337c0,17.989,7.028,33.993,22.122,39.956
                                        c2.467,0.974,4.698,0.036,5.408-2.613l2.203-8.403c0.728-2.613,0.446-3.541-1.548-5.826c-4.361-4.962-7.128-11.398-7.128-20.511
                                        c0-26.428,20.42-50.089,53.175-50.089c29.014,0,44.945,17.161,44.945,40.075c0,30.152-13.783,55.606-34.248,55.606
                                        c-11.289,0-19.755-9.04-17.042-20.156c3.241-13.237,9.541-27.539,9.541-37.107c0-8.548-4.743-15.704-14.575-15.704
                                        c-11.553,0-20.829,11.571-20.829,27.074c0,9.878,3.45,16.551,3.45,16.551l-13.901,56.998c-4.124,16.906-0.61,37.644-0.319,39.738
                                        c0.182,1.238,1.821,1.529,2.567,0.601c1.065-1.347,14.821-17.798,19.5-34.239c1.329-4.652,7.602-28.75,7.602-28.75
                                        c3.751,6.946,14.721,13.046,26.383,13.046c34.712,0,58.273-30.652,58.273-71.674C218.444,92.676,191.315,63.781,150.066,63.781z"/>
                                </g>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="13">
                            <img class="platform_img platform_img_24" src="{{ imgRoute }}assets/img/ViewBug_Icon.png" alt="">
                        </ng-container>
                        <ng-container *ngSwitchCase="14">
                            <img class="platform_img platform_img_24 platform_img_invert" src="{{ imgRoute }}assets/img/1x-logo-2.png" alt="">
                        </ng-container>
                        <ng-container *ngSwitchCase="15">
                            <img class="platform_img platform_img_24" src="{{ imgRoute }}assets/img/guru.png" alt="">
                        </ng-container>
                        <ng-container *ngSwitchCase="16">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 473.958 473.958" style="enable-background:new 0 0 473.958 473.958;" xml:space="preserve">
                                <path style="fill:#E1E1E1;" d="M0.001,236.981C0.001,106.094,106.099,0,236.974,0c130.883,0,236.981,106.094,236.981,236.981
                                c0,130.872-106.098,236.977-236.981,236.977C106.099,473.958,0.001,367.852,0.001,236.981z"/>
                                <path style="fill:#D5D5D5;" d="M404.545,69.406c92.545,92.545,92.552,242.59,0,335.138c-92.541,92.541-242.593,92.549-335.142,0
                                L404.545,69.406z"/>
                                <path style="fill:#CCCBCB;" d="M466.299,296.89l-111.28-111.276l-76.706,76.71l-72.964-72.968l-87.112,87.116l187.361,187.357
                                C384.164,440.095,445.506,376.69,466.299,296.89z"/>
                                <path style="fill:#3A58A6;" d="M161.978,171.099c-34.271,0-62.053,27.551-62.053,61.541c0,33.975,27.783,61.515,62.053,61.515
                                s62.05-27.539,62.05-61.515C224.028,198.65,196.249,171.099,161.978,171.099z"/>
                                <path style="fill:#E62D7E;" d="M376.815,232.64c0,33.975-27.775,61.515-62.053,61.515c-34.271,0-62.05-27.539-62.05-61.515
                                c0-33.99,27.779-61.541,62.05-61.541C349.04,171.099,376.815,198.65,376.815,232.64z"/>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="17">
                            <img class="platform_img platform_img_24 platform_img_r" src="{{ imgRoute }}assets/img/fs.png" alt="">
                        </ng-container>
                        <ng-container *ngSwitchCase="18">
                            <svg class="without_back" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                                <g>
                                    <path d="M10.5,10H6v5h4h0.5c1.4,0,2.5-1.1,2.5-2.5S11.9,10,10.5,10z"/>
                                    <path fill="#1769FF" d="M23,0H9C4,0,0,4,0,9v14c0,5,4,9,9,9h14c5,0,9-4,9-9V9C32,4,28,0,23,0z"/>
                                </g>
                                <g>
                                    <g>
                                        <path fill="#FFFFFF" d="M19,12h6c0.6,0,1-0.4,1-1s-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1S18.4,12,19,12z"/>
                                        <path fill="#FFFFFF" d="M28,19c0-3.3-2.7-6-6-6s-6,2.7-6,6s2.7,6,6,6c1.4,0,2.7-0.5,3.8-1.4c0.6-0.5,1-1,1.4-1.6
                                            c0.3-0.5,0.1-1.1-0.4-1.4c-0.5-0.3-1.1-0.1-1.4,0.4c-0.2,0.4-0.6,0.8-0.9,1.1C23.8,22.7,22.9,23,22,23c-1.9,0-3.4-1.3-3.9-3H27
                                            C27.6,20,28,19.6,28,19z M18.1,18c0.4-1.7,2-3,3.9-3s3.4,1.3,3.9,3H18.1z"/>
                                        <path fill="#FFFFFF" d="M15,12.5C15,10,13,8,10.5,8H5C4.4,8,4,8.4,4,9v7v8c0,0.6,0.4,1,1,1h5c2.8,0,5-2.2,5-5c0-1.6-0.7-2.9-1.9-3.9
                                            C14.3,15.3,15,14,15,12.5z M10,23H6v-6h4c1.7,0,3,1.3,3,3S11.7,23,10,23z M10.5,15H10H6v-5h4.5c1.4,0,2.5,1.1,2.5,2.5
                                            S11.9,15,10.5,15z"/>
                                    </g>
                                </g>
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="19">
                            <svg class="without_back" width="64px" height="64px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-width="0" fill="#333333" d="M32 0 C14 0 0 14 0 32 0 53 19 62 22 62 24 62 24 61 24 60 L24 55 C17 57 14 53 13 50 13 50 13 49 11 47 10 46 6 44 10 44 13 44 15 48 15 48 18 52 22 51 24 50 24 48 26 46 26 46 18 45 12 42 12 31 12 27 13 24 15 22 15 22 13 18 15 13 15 13 20 13 24 17 27 15 37 15 40 17 44 13 49 13 49 13 51 20 49 22 49 22 51 24 52 27 52 31 52 42 45 45 38 46 39 47 40 49 40 52 L40 60 C40 61 40 62 42 62 45 62 64 53 64 32 64 14 50 0 32 0 Z" />
                            </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="20">
                          <svg class="without_back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 20">
                              <title>500px</title>
                              <path d="M24.83,0a10,10,0,1,0,10,10h0A10.09,10.09,0,0,0,24.83,0Zm0,17.9a7.85,7.85,0,1,1,7.8-7.9h0A7.9,7.9,0,0,1,24.83,17.9ZM46.32,0a10,10,0,1,0,10,10h0A10,10,0,0,0,46.32,0Zm0,17.9a7.85,7.85,0,1,1,7.8-7.9h0A7.77,7.77,0,0,1,46.32,17.9ZM7.63,6a6.74,6.74,0,0,0-5.3,1.4V2.1h9c0.3,0,.5-0.1.5-1s-0.4-.9-0.6-0.9H1.33a0.9,0.9,0,0,0-.9.9V9.9c0,0.5.3,0.6,0.8,0.7a0.76,0.76,0,0,0,.9-0.2h0a5.69,5.69,0,0,1,5-2.4,5.2,5.2,0,0,1,4.5,4.4A5.06,5.06,0,0,1,7.23,18H6.63a5.1,5.1,0,0,1-4.7-3.3c-0.1-.3-0.3-0.5-1.1-0.2s-0.9.5-.8,0.8a7.09,7.09,0,0,0,9,4.2,7.09,7.09,0,0,0,4.2-9A7,7,0,0,0,7.63,6ZM63.12,0.1a5.42,5.42,0,0,0-4.8,5.4v8.9c0,0.5.4,0.6,1,.6s1-.1,1-0.6V5.5a3.36,3.36,0,0,1,2.9-3.4,3.29,3.29,0,0,1,2.5.8,3.19,3.19,0,0,1,1.1,2.4,4,4,0,0,1-.7,1.9,3.15,3.15,0,0,1-2.8,1.3h0c-0.4,0-.7,0-0.8.9,0,0.6,0,.9.5,1a4.92,4.92,0,0,0,2.9-.6,5.37,5.37,0,0,0,2.9-4.2A5.18,5.18,0,0,0,64,0,2.77,2.77,0,0,1,63.12.1Zm13.1,5.2,3.6-3.6c0.1-.1.4-0.4-0.2-1.1a1,1,0,0,0-.7-0.4h0a0.52,0.52,0,0,0-.4.2L74.92,4l-3.6-3.7c-0.3-.3-0.6-0.2-1.1.2s-0.5.8-.2,1.1l3.6,3.6L70,8.9h0a0.76,0.76,0,0,0-.2.4,0.84,0.84,0,0,0,.4.7,1.61,1.61,0,0,0,.7.4h0a1.06,1.06,0,0,0,.5-0.2L75,6.6l3.6,3.6a0.52,0.52,0,0,0,.4.2h0a1,1,0,0,0,.7-0.4c0.3-.4.4-0.8,0.1-1Z" transform="translate(0)"></path>
                          </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="21">
                            <svg class="without_back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 780 300">
                                <polygon fill="#333" points="780 300 702 300 702 270 750 270 750 30 702 30 702 0 780 0 780 300"/>
                                <polygon fill="#333" points="78 30 30 30 30 270 78 270 78 300 0 300 0 0 78 0 78 30"/>
                                <path fill="#333" d="M275.16,126A53.82,53.82,0,0,0,258,114.12,52.75,52.75,0,0,0,199,126a57.12,57.12,0,0,0-11.5,17.82,57.86,57.86,0,0,0-4.25,22.27,57.1,57.1,0,0,0,4.25,22.17A56.16,56.16,0,0,0,199,205.85a53.27,53.27,0,0,0,17,11.74,53.8,53.8,0,0,0,42,0,54.52,54.52,0,0,0,17.13-11.73,55.42,55.42,0,0,0,11.62-17.63A57.15,57.15,0,0,0,291,166.05a57.93,57.93,0,0,0-4.25-22.27A56.35,56.35,0,0,0,275.16,126Zm-29,65.77a21.62,21.62,0,0,1-9,1.92,22.29,22.29,0,0,1-9.13-1.93,21.37,21.37,0,0,1-7.44-5.49,27.78,27.78,0,0,1-5.05-8.68,32.4,32.4,0,0,1-1.88-11.3,34.11,34.11,0,0,1,1.89-11.52,28.64,28.64,0,0,1,5.06-9,22,22,0,0,1,7.46-5.69,21.37,21.37,0,0,1,9.1-2,20.72,20.72,0,0,1,9,2,23.34,23.34,0,0,1,7.49,5.71,27.54,27.54,0,0,1,5.14,9,34.11,34.11,0,0,1,1.89,11.52,32.4,32.4,0,0,1-1.88,11.3,26.73,26.73,0,0,1-5.13,8.66A22.71,22.71,0,0,1,246.14,191.73Z"/>
                                <path fill="#333" d="M404,173.77c0,6.73-.15,13.47-2.43,19.26a44.26,44.26,0,0,1-25.16,25.33A52.19,52.19,0,0,1,356.7,222a53.82,53.82,0,0,1-20-3.53,41.9,41.9,0,0,1-24.48-25.08A56.28,56.28,0,0,1,309,174V110h30v65a30.11,30.11,0,0,0,.56,5.12,16.53,16.53,0,0,0,2.3,5.78,14.18,14.18,0,0,0,5,4.71c2.18,1.28,5.31,1.92,9.29,1.92,5.31,0,9.52-1.61,12.85-4.91A16.85,16.85,0,0,0,374,175V110h30Z"/>
                                <rect fill="#333" x="547" y="110" width="30" height="112"/>
                                <path fill="#333" d="M670.23,180.56l-.54,1.13A21.77,21.77,0,0,1,662,190.2a22.07,22.07,0,0,1-21.42,1.46,24.19,24.19,0,0,1-7.76-5.92,29.72,29.72,0,0,1-5.34-8.91,29.31,29.31,0,0,1-2-10.67,30.68,30.68,0,0,1,2-11,29.52,29.52,0,0,1,5.33-9,25.58,25.58,0,0,1,7.79-6,21.11,21.11,0,0,1,21.08,1.36,24.29,24.29,0,0,1,7.87,8.4l.57,1.05h32l-.66-2.51C698.24,136.32,692,126.74,683,120s-20.18-10.2-33.1-10.2a54.91,54.91,0,0,0-22.2,4.47,54.1,54.1,0,0,0-17.44,12,55.76,55.76,0,0,0-11.41,17.83A58,58,0,0,0,594.68,166a57.21,57.21,0,0,0,4.15,21.76,56,56,0,0,0,11.41,17.73,52.75,52.75,0,0,0,17.46,12,56,56,0,0,0,22.19,4.36c12.92,0,24.08-3.43,33.19-10.19s15.37-16.37,18.54-28.5l.66-2.51Z"/>
                                <polygon fill="#333" points="168.39 78 139.91 135.04 111.61 78 77.67 78 125 166.23 125 222 155 222 155 166.23 202.34 78 168.39 78"/>
                                <path fill="#333" d="M517.07,90.76A41.66,41.66,0,0,0,502,81.32,57.5,57.5,0,0,0,481.94,78H422V222h30V171h30.53a52.6,52.6,0,0,0,19.29-3.43,43.35,43.35,0,0,0,15-9.63,42.55,42.55,0,0,0,9.53-14.76,50.67,50.67,0,0,0,3.33-18.49,54.67,54.67,0,0,0-3.22-19.16A41,41,0,0,0,517.07,90.76ZM452,107h29.47c5.52,0,9.86,1.42,12.9,4.22s4.51,7.4,4.51,13.78-1.52,11-4.51,13.78S487,143,481.47,143H452Z"/>
                              </svg>
                        </ng-container>
                        <ng-container *ngSwitchCase="22">
                          <svg class="without_back" viewBox="0 0.4 959.3 823.9" xmlns="http://www.w3.org/2000/svg" width="2500" height="2146"><path d="M479.7 649.9L852.8.4h106.5L480 824.3l-.3-.7-.4.7L0 .4h726.6L417.7 538z" fill="#333333"/></svg>
                      </ng-container>
                      <ng-container *ngSwitchCase="23">
                          <svg class="without_back" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
                              <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
                                  <path d="M 0 6.447 C 0 2.887 2.978 0 6.651 0 h 76.698 C 87.022 0 90 2.887 90 6.447 v 77.106 C 90 87.114 87.022 90 83.349 90 H 6.651 C 2.978 90 0 87.114 0 83.553 V 6.447 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,102,153); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                  <path d="M 20.485 29.151 c 4.74 0 7.691 -3.121 7.691 -7.021 c -0.088 -3.988 -2.95 -7.022 -7.601 -7.022 c -4.65 0 -7.69 3.034 -7.69 7.022 c 0 3.9 2.95 7.021 7.512 7.021 H 20.485 L 20.485 29.151 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                  <path d="M 27.282 75.339 v -40.64 H 13.688 v 40.64 H 27.282 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                  <path d="M 34.804 75.339 h 13.594 V 52.644 c 0 -1.215 0.088 -2.428 0.447 -3.296 c 0.983 -2.427 3.219 -4.94 6.975 -4.94 c 4.919 0 6.887 3.727 6.887 9.19 v 21.741 h 13.592 V 52.037 c 0 -12.483 -6.706 -18.291 -15.65 -18.291 c -7.333 0 -10.553 4.073 -12.342 6.847 h 0.091 v -5.894 H 34.804 C 34.982 38.513 34.804 75.339 34.804 75.339 L 34.804 75.339 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                              </g>
                          </svg>
                      </ng-container>
                      </div>
                      {{ profile.name }}
                  </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>
      
              <mat-form-field appearance="standard" class="filter_form">
                <mat-label>{{ "By content status" | translate }}</mat-label>
                <mat-select formControlName="content_status_id">
                  <mat-option *ngFor="let status of profileStatuses" [value]="status.id">
                      {{ status.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
      
          
              <mat-form-field appearance="standard" class="filter_form">
                <mat-label>{{ "By content url" | translate }}</mat-label>
                <mat-select formControlName="is_content_url">
                  <mat-option *ngFor="let content of contentUrl" [value]="content.id">
                      {{ content.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          
              <mat-form-field appearance="standard" class="example-form-field">
                <mat-label>{{ 'By date range' | translate }}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                  <input formControlName="operation_completed_at_from" matStartDate placeholder="{{ 'Date from' | translate }}">
                  <input formControlName="operation_completed_at_to" matEndDate placeholder="{{ 'Date to' | translate }}">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div> -->

      <div class="tasks_wrp" #tasksContainer>
        <div *ngIf="is_mobile" (click)="toggleMobCollection($event)" class="btn_select" [ngClass]="{'scrolled': isScrolledCollectionBtn || collectionIsActive}">
          <mat-icon class="mr-1">check_circle_outline</mat-icon>
          {{ "Select" | translate }}
        </div>
        <!-- [ngClass]="{'highlight_task': task.is_read == '0'}" -->
        <div class="task_out" *ngFor="let task of tasks; let i = index;" >
          
            <div class="container task" (click)="openTask($event, task, i)" *ngIf="!is_mobile; else elseTemplateTASK">
              <div class="task_btns" [ngClass]="{'show': taskCollection.isSelected(task.id)}">
                <button mat-icon-button (click)="checkActions($event, task)">
                  <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.6905 5.47619H12.0476V10.9524L16.7352 13.7343L17.5238 12.409L13.6905 10.131V5.47619ZM13.1429 0C10.5286 0 8.02138 1.03852 6.1728 2.88709C4.32423 4.73566 3.28571 7.24287 3.28571 9.85714H0L4.33714 14.271L8.7619 9.85714H5.47619C5.47619 7.82382 6.28393 5.87377 7.72171 4.43599C9.15948 2.99821 11.1095 2.19048 13.1429 2.19048C15.1762 2.19048 17.1262 2.99821 18.564 4.43599C20.0018 5.87377 20.8095 7.82382 20.8095 9.85714C20.8095 11.8905 20.0018 13.8405 18.564 15.2783C17.1262 16.7161 15.1762 17.5238 13.1429 17.5238C11.029 17.5238 9.11238 16.6586 7.73238 15.2676L6.17714 16.8229C7.96238 18.619 10.4048 19.7143 13.1429 19.7143C15.7571 19.7143 18.2643 18.6758 20.1129 16.8272C21.9615 14.9786 23 12.4714 23 9.85714C23 7.24287 21.9615 4.73566 20.1129 2.88709C18.2643 1.03852 15.7571 0 13.1429 0Z" fill="#686868"/>
                  </svg>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="showFilesInterface(task)" *ngIf="(company?.permissions.includes('owner') || checkIsManager(task, company, user)) && (company | perm:'see_files')">
                    <mat-icon>perm_media</mat-icon> 
                    <span>{{ "Files" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="anCardScen(task)">
                    <mat-icon>rebase_edit</mat-icon>
                    <span>{{ 'Set scenario' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="openTagConnection(task)">
                    <mat-icon>account_tree</mat-icon>
                    <span>{{ 'Set card for tag' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="openNotes(task)">
                    <mat-icon>text_snippet</mat-icon>
                    <span>{{ 'Notes' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="openAccessSettings(task)">
                    <mat-icon>settings_applications</mat-icon>
                    <span>{{ "Access Settings" | translate }}</span>
                  </button>
                  <!-- <button mat-menu-item (click)="addNote(task)">
                    <mat-icon>playlist_add_circle</mat-icon>
                    <span>{{ 'Add Note' | translate }}</span>
                  </button> -->
                  <button mat-menu-item (click)="toShortCut($event, task)">
                    <div class="d-f-c">
                      <svg width="18" style="margin-right: 16px;" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 0L5.778 5.004L0 6.516L3.78 11.142L3.438 17.1L9 14.931L14.562 17.1L14.22 11.142L18 6.516L12.222 5.004L9 0ZM6.642 7.2C7.2 7.2 7.65 7.65 7.65 8.217C7.65 8.48434 7.5438 8.74073 7.35476 8.92976C7.16573 9.1188 6.90934 9.225 6.642 9.225C6.075 9.225 5.625 8.775 5.625 8.217C5.625 7.65 6.075 7.2 6.642 7.2ZM11.367 7.2C11.925 7.2 12.375 7.65 12.375 8.217C12.375 8.48434 12.2688 8.74073 12.0798 8.92976C11.8907 9.1188 11.6343 9.225 11.367 9.225C10.8 9.225 10.35 8.775 10.35 8.217C10.35 7.65 10.8 7.2 11.367 7.2ZM6.3 11.25H11.7C11.25 12.339 10.179 13.05 9 13.05C7.821 13.05 6.75 12.339 6.3 11.25Z" fill="#686868"/>
                      </svg>
                      <span>{{ "Shortcut" | translate }}</span>
                    </div>
                  </button>
                  <button mat-menu-item (click)="addProfile(task)" *ngIf="company | perm:'see_task_channels'">
                    <mat-icon>add</mat-icon> 
                    <span>{{ "Add URL to Publication" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="addChannel(task)" *ngIf="company | perm:'see_task_channels'">
                    <mat-icon>add</mat-icon> 
                    <span>{{ "Add Channel" | translate }}</span>
                  </button>
                  <div class="munu_items">
                    <button mat-menu-item (click)="addLive(task)">
                        <div class="cst_menu_inside_item">
                            <mat-icon style="width: 18px; height: 18px; font-size: 18px; line-height: 18px; background: transparent; color: #A3A3A3;">live_tv</mat-icon>
                            <span>{{ "Livestream" | translate }}</span>
                        </div>
                    </button>
                    <div class="split">|</div>
                    <button mat-menu-item (click)="addLiveAuto(task)">
                        <div class="cst_menu_inside_item">
                            <span>{{ "For automatization" | translate }}</span>
                        </div>
                    </button>
                  </div>
                  <button mat-menu-item (click)="migrateTargetFiles(task)" *ngIf="!!user?.is_root">
                    <mat-icon>move_up</mat-icon> 
                    <span>{{ "Migrate all card files" | translate }}</span>
                  </button>
                  <button mat-menu-item *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager') || company?.permissions.includes('assign_task_parameter')" (click)="openTargetValues([task.id, 0, 0], task)">
                    <mat-icon>settings_suggest</mat-icon> 
                    <span>{{ "Tags" | translate }}</span>
                  </button>
                  <ng-container *ngIf="(company?.permissions.includes('owner') || checkIsManager(task, company, user)) && task?.company_id == company?.id; else elseTemplateBtns">
                    <button mat-menu-item ngxClipboard [cbContent]="origin + '/task/' + task.acm" (cbOnSuccess)="copyLink('Card')">
                      <mat-icon>link</mat-icon> 
                      <span>{{ "Copy card url" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="addWork(task)" *ngIf="company && company?.permissions?.includes('create_task_operation')">
                      <mat-icon>work</mat-icon> 
                      <span>{{ "Add work" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="moveAllJobs(task)">
                      <mat-icon>move_down</mat-icon> 
                      <span>{{ "Move All Jobs" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="taskManagers(task)">
                      <mat-icon>manage_accounts</mat-icon> 
                      <span>{{ "Task managers" | translate }}</span>
                    </button>
                    <ng-container *ngIf="task.group_id == 0; else elseGroupTemplate">
                      <button mat-menu-item (click)="addGroup(task)">
                        <mat-icon>group</mat-icon> 
                        <span>{{ "Add group" | translate }}</span>
                      </button>
                    </ng-container>
                    <ng-template #elseGroupTemplate>
                      <button mat-menu-item (click)="editGroup(task)">
                        <mat-icon>edit</mat-icon> 
                        <span>{{ "Edit group" | translate }}</span>
                      </button>
                      <!-- <button mat-menu-item (click)="deleteGroup(task)">
                        <mat-icon>delete</mat-icon> 
                        <span>{{ "Delete group" | translate }}</span>
                      </button> -->
                    </ng-template>
                    
                    <button mat-menu-item (click)="goToClients(task)">
                      <mat-icon>group</mat-icon> 
                      <span>{{ "Clients" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="goToEditTask(task)">
                      <mat-icon>edit</mat-icon> 
                      <span>{{ "Edit" | translate }}</span>
                    </button>
                    <button *ngIf="company?.permissions?.includes('owner') || company?.permissions?.includes('admin')" mat-menu-item (click)="deleteTask(task)">
                      <mat-icon>delete</mat-icon> 
                      <span>{{ "Delete" | translate }}</span>
                    </button>
                  </ng-container>
                  <ng-template #elseTemplateBtns>
                    <button *ngIf="!company?.permissions.includes('client') || task?.company_id != company?.id" mat-menu-item (click)="addEmplWork(task)">
                      <mat-icon>work</mat-icon> 
                      <span>{{ "Add work" | translate }}</span>
                    </button>
                  </ng-template>
                </mat-menu>
                <div class="check_wrp">
                  <mat-checkbox color="primary" class="example-margin" (click)="clickOnCheck($event, task, i); $event.stopPropagation()" (change)="$event ? toggleTask(task) : null" [checked]='taskCollection.isSelected(task.id)'></mat-checkbox>
                </div>
              </div>


              <div class="card_wrp" (contextmenu)="openCardContext($event, task); $event.preventDefault(); $event.stopPropagation();">
                <div class="card_info">
                  <div class="left">
                    
                    <div class="s_i">
                      <div class="status">
                        {{ getTaskStatusById(task?.status_id)?.name }}
                      </div>
                      <div class="ids">
                        <div>{{task.custom_id}}</div>
                        <div>{{task.internal_id}}</div>
                      </div>
                    </div>
    
                    <div class="card_name text_one_line">
                      {{task.name}}
                    </div>
    
                    <div class="g_d">
                      <div class="card_group" *ngIf="task.group_id">
                        {{ task?.group?.name || getGroup(task.group_id)?.name }}
                      </div>
                      <div class="card_dates">
    
                        <div>
                          <ng-container *ngIf="isES; else elseTemplateESDateDesk">
                            <ng-container *ngIf="task.updated_at > today; else updatedAtTemplESDesk">
                              {{ (task.updated_at*1000 | date:'hh:mm a':'':activeLang) }}
                            </ng-container>
                            <ng-template #updatedAtTemplESDesk>
                              {{ (task.updated_at*1000 | date:'MMM dd, Y':'':activeLang | yearPipe).replaceAll('.', '') }}
                            </ng-template>
                          </ng-container>
                          <ng-template #elseTemplateESDateDesk>        
                            <ng-container *ngIf="task.action_updated_at > today; else updatedAtTemplDesk">
                              {{ (task.action_updated_at*1000 | date:'hh:mm a':'':activeLang) }}
                            </ng-container>
                            <ng-template #updatedAtTemplDesk>
                              {{ (task.action_updated_at*1000 | date:'MMM dd, Y':'':activeLang | yearPipe).replaceAll('.', '') }}
                            </ng-template>
                          </ng-template>
                        </div>
    
                        <div>
                          <ng-container *ngIf="task.created_at > today; else createdAtTemplDesk">
                            {{ (task.created_at*1000 | date:'hh:mm a':'':activeLang) }}
                          </ng-container>
                          <ng-template #createdAtTemplDesk>
                            {{ (task.created_at*1000 | date:'MMM dd, Y':'':activeLang | yearPipe).replaceAll('.', '') }}
                          </ng-template>
                        </div>
                      </div>
                    </div>
    
                    <ng-container *ngIf="!!isES && task?.meta && task?.meta?.task_operations_by_operation_arr; else elseTemplateESJobs">                      
                      <div class="card_jobs_wrp" [ngClass]="{'to_start': task?.meta?.task_operations_by_operation_arr.length <= 1}">
                        <div class="card_jobs" *ngIf="task?.meta?.task_operations_by_operation_arr.length;">
                          <div class="job_out" *ngFor="let op of task?.meta?.task_operations_by_operation_arr; let u = index;" [ngStyle]="{'margin-right': (op?.by_status_arr.slice(1).length > 0 ? (17.5 + (op?.by_status_arr.slice(1).length - 1)*5) : 3.5) + 'px', 'margin-left': 3.5 + (op?.executors.length > 3 ? 3*15 : op?.executors.length > 0 ? ((op?.executors.length - 1)*15) : 0) + 'px'}">
                            <div class="job" [ngClass]="{
                              'first': op?.by_status_arr[0]?.status_id == '1',
                              'second': op?.by_status_arr[0]?.status_id == '2',
                              'third': op?.by_status_arr[0]?.status_id == '3',
                              'fours': op?.by_status_arr[0]?.status_id == '4',
                              'fives': op?.by_status_arr[0]?.status_id == '5',
                              'sixs': op?.by_status_arr[0]?.status_id == '6',
                              'nine': op?.by_status_arr[0]?.status_id == '97',
                              'seven': op?.by_status_arr[0]?.status_id == '98',
                              'eight': op?.by_status_arr[0]?.status_id == '99'
                            }">
                              <div class="employees" *ngIf="op?.executors?.length">
                                <ng-container *ngIf="op?.executors.length > 3;">
                                  <div class="plus">
                                    +{{op?.executors.length - 3}}
                                  </div>
                                </ng-container>
        
                                <div class="more_empls">
                                  <ng-container *ngFor="let item of op?.executors; let u = index;">
                                    <ng-container *ngIf="u <= 2">
                                        <ng-container *ngIf="item?.is_partner; else elsePartner">
                                          <ng-container *ngIf="!!getPartnerById(item?.id)?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                            <img [appHoverUserInfo]="{ user: {partnerCompany: getPartnerById(item?.id)}, company_id: company?.id }" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}"
                                            matTooltip="{{getPartnerById(item?.id)?.name}}"
                                            [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + getPartnerById(item?.id)?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                                          </ng-container>
                                          <ng-template #elseTemplatePartnerAvatar>
                                            <img [appHoverUserInfo]="{ user: {partnerCompany: getPartnerById(item?.id)}, company_id: company?.id }" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}"
                                            matTooltip="{{getPartnerById(item?.id)?.name}}"
                                            [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                                          </ng-template>
                                        </ng-container>
                                        <ng-template #elsePartner>
                                          <ng-container *ngIf="getEmployeeById(item?.id)?.image; else elseMobWorkTemplate">
                                            <img #tooltip="matTooltip" [appHoverUserInfo]="{ user: getEmployeeById(item?.id), company_id: company?.id }"
                                            matTooltip="{{getEmployeeById(item?.id)?.name}}"
                                            [matTooltipPosition]="'above'" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" [src]="getEmployeeById(item?.id)?.image" alt="" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}">
                                          </ng-container>
                                          <ng-template #elseMobWorkTemplate>
                                            <mat-icon [appHoverUserInfo]="{ user: getEmployeeById(item?.id), company_id: company?.id }" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}"
                                            matTooltip="{{getEmployeeById(item?.id)?.name}}"
                                            [matTooltipPosition]="'above'">account_circle</mat-icon>
                                          </ng-template>
                                        </ng-template>
                                    </ng-container>      
                                  </ng-container>
                                </div>
                              </div>
                              <span class="text_2_line">
                                {{ getJobTypeById(op.operation_id)?.name }}
                              </span>
                              <div class="circles" *ngIf="op?.by_status_arr.slice(1).length > 0">
                                <div class="circle" *ngFor="let item of op?.by_status_arr.slice(1); let j = index;" [ngClass]="{
                                  'first': item.status_id == '1',
                                  'second': item.status_id == '2',
                                  'third': item.status_id == '3',
                                  'fours': item.status_id == '4',
                                  'fives': item.status_id == '5',
                                  'sixs': item.status_id == '6',
                                  'nine': item.status_id == '97',
                                  'seven': item.status_id == '98',
                                  'eight': item.status_id == '99'
                                }" 
                                [ngStyle]="{'z-index': op.by_status_arr.length - j, 'right': '-' + (14 + j*5) + 'px'}"
                                >
                                  <ng-container *ngIf="op.count >= 2 && j == 0">{{op.count - 1}}</ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container *ngIf="task?.meta?.task_operations_by_operation_arr.length <= 1">
                          <div class="task_comments_wrp" *ngIf="(task?.comment || task?.private_comment)" >
                            <div class="comment" [innerHTML]='task?.comment ? task?.comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' *ngIf="task?.comment" [ngClass]="{'text_one_line': task?.private_comment, 'text_2_line': !task?.private_comment}">
                            </div>
                            <div class="private_comment" *ngIf="task?.private_comment" [innerHTML]='task?.private_comment ? task?.private_comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' [ngClass]="{'text_one_line': task?.comment, 'text_2_line': !task?.comment}">
                            </div>
                            
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-template #elseTemplateESJobs>        
                      <div class="card_jobs_wrp" [ngClass]="{'to_start': task?.worksByTypeAndStatus.length <= 1}">
                        <div class="card_jobs" *ngIf="task?.worksByTypeAndStatus.length;">
                          <div class="job_out" *ngFor="let op of task?.worksByTypeAndStatus; let u = index;" [ngStyle]="{'margin-right': (op?.statuses.slice(1).length > 0 ? (17.5 + (op?.statuses.slice(1).length - 1)*5) : 3.5) + 'px', 'margin-left': 3.5 + (op.allEmpl.length > 3 ? 3*15 : op.allEmpl.length > 0 ? ((op.allEmpl.length - 1)*15) : 0) + 'px'}">
                            <div class="job" [ngClass]="{
                              'first': op?.statuses[0]?.name == '1',
                              'second': op?.statuses[0]?.name == '2',
                              'third': op?.statuses[0]?.name == '3',
                              'fours': op?.statuses[0]?.name == '4',
                              'fives': op?.statuses[0]?.name == '5',
                              'sixs': op?.statuses[0]?.name == '6',
                              'nine': op?.statuses[0]?.name == '97',
                              'seven': op?.statuses[0]?.name == '98',
                              'eight': op?.statuses[0]?.name == '99'
                            }">
                              <div class="employees" *ngIf="op?.allEmpl.length">
                                <ng-container *ngIf="op?.allEmpl.length > 3;">
                                  <div class="plus">
                                    +{{op?.allEmpl.length - 3}}
                                  </div>
                                </ng-container>
        
                                <div class="more_empls">
                                  <ng-container *ngFor="let item of op?.allEmpl; let u = index;">
                                    <ng-container *ngIf="u <= 2">
                                      <ng-container *ngIf="item?.employee?.image; else elseMobWorkTemplate">
                                        <img #tooltip="matTooltip" [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }"
                                        matTooltip="{{item?.employee?.name}}"
                                        [matTooltipPosition]="'above'" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" [src]="item?.employee?.image" alt="" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}">
                                      </ng-container>
                                      <ng-template #elseMobWorkTemplate>
                                        <ng-container *ngIf="item?.is_partner; else elsePartner">
                                          <ng-container *ngIf="!!item?.partnerCompany?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                            <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}"
                                            matTooltip="{{item?.partnerCompany?.name}}"
                                            [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + item?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                                          </ng-container>
                                          <ng-template #elseTemplatePartnerAvatar>
                                            <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}"
                                            matTooltip="{{item?.partnerCompany?.name}}"
                                            [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                                          </ng-template>
                                        </ng-container>
                                        <ng-template #elsePartner>
                                          <mat-icon [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}"
                                          matTooltip="{{item?.employee?.name}}"
                                          [matTooltipPosition]="'above'">account_circle</mat-icon>
                                        </ng-template>
                                      </ng-template>
                                    </ng-container>      
                                  </ng-container>
                                </div>
                              </div>
                              <span class="text_2_line">
                                {{ op.type }}
                              </span>
                              <div class="circles" *ngIf="op?.statuses.slice(1).length > 0">
                                <div class="circle" *ngFor="let item of op?.statuses.slice(1); let j = index;" [ngClass]="{
                                  'first': item.name == '1',
                                  'second': item.name == '2',
                                  'third': item.name == '3',
                                  'fours': item.name == '4',
                                  'fives': item.name == '5',
                                  'sixs': item.name == '6',
                                  'nine': item.name == '97',
                                  'seven': item.name == '98',
                                  'eight': item.name == '99'
                                }" 
                                [ngStyle]="{'z-index': op.statuses.length - j, 'right': '-' + (14 + j*5) + 'px'}"
                                >
                                <ng-container *ngIf="op.count >= 2 && j == 0">{{op.count - 1}}</ng-container>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <ng-container *ngIf="task?.worksByTypeAndStatus.length <= 1">
                          <div class="task_comments_wrp" *ngIf="(task?.comment || task?.private_comment)" >
                            <div class="comment" [innerHTML]='task?.comment ? task?.comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' *ngIf="task?.comment" [ngClass]="{'text_one_line': task?.private_comment, 'text_2_line': !task?.private_comment}">
                            </div>
                            <div class="private_comment" *ngIf="task?.private_comment" [innerHTML]='task?.private_comment ? task?.private_comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' [ngClass]="{'text_one_line': task?.comment, 'text_2_line': !task?.comment}">
                            </div>
                            
                          </div>
                        </ng-container>
                      </div>
                    </ng-template>
                    
                  </div>
                  <div class="right">
                    <div class="task_profiles" *ngIf="task?.previewImgs.length || (task?.avatarFile && task?.avatarFile?.thumbnail);">
                      <swiper [ngClass]="{'p-b': task?.previewImgs.length > 1 || (task?.avatarFile && task?.avatarFile?.thumbnail)}" [pagination]="task?.previewImgs.length > 1 ? { clickable: true } : false" [navigation]="false">
                          <ng-container *ngIf="task?.previewImgs.length > 0 && task?.custom_avatar_property == ''; else elseTemplateHasPreview">
                            <ng-container *ngFor="let preview of task?.previewImgs">
                              <ng-template swiperSlide>
                                <div class="preview_img" [lazyLoad]="(!preview.is_parser_url ? host : '') + preview.src"></div>
                              </ng-template>
                            </ng-container>
                          </ng-container>
                          <ng-template #elseTemplateHasPreview>
                            <ng-template swiperSlide>
                              <div class="preview_img" [lazyLoad]="host + task?.avatarFile?.thumbnail + '?company_id=' + company?.id"></div>
                            </ng-template>
                          </ng-template>
                      </swiper>
                    </div>
                  </div>
  
                  <div class="task_comments_wrp" *ngIf="(task?.comment || task?.private_comment) && ((!isES && task?.worksByTypeAndStatus.length > 1) || (isES && task?.meta?.task_operations_by_operation_arr.length > 1))">
                    <div class="comment" [innerHTML]='task?.comment ? task?.comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' *ngIf="task?.comment" [ngClass]="{'text_one_line': task?.private_comment, 'text_2_line': !task?.private_comment}">
                    </div>
                    <div class="private_comment" [innerHTML]='task?.private_comment ? task?.private_comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' *ngIf="task?.private_comment" [ngClass]="{'text_one_line': task?.comment, 'text_2_line': !task?.comment}">
                    </div>
                  </div>
                </div>
  
                <div class="card_media">

                  <div class="card_btns">
                    
                    <div class="up" *ngIf="(task.consist_of_count != '0' || task.part_of_count != '0' || task.related_count != '0') || task?.chatsInfo?.length || (task.filesize && (company | perm:'see_files')); else elseTemplateUP">
  
                      <div class="card_cons_out" (click)="$event.stopPropagation(); checkConnections($event, task)" *ngIf="task.consist_of_count != '0' || task.part_of_count != '0' || task.related_count != '0'">
                        <svg class="card_cons" style="cursor: pointer;" width="31" height="36" viewBox="0 0 31 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.6602 15.5002L20.1602 9.5" stroke="#A7A7A7"/>
                          <line x1="10.4174" y1="20.5713" x2="20.4174" y2="26.5713" stroke="#A7A7A7"/>
                          <circle #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{'Part of' | translate }}" class="cl" cx="5.76" cy="17.76" r="5.26" [ngStyle]="{'stroke': card_exp === 1 ? (task?.partOfTaskPartition?.length != 0 ? '#5B79AC' : '#A7A7A7') : (task?.consist_of_count != 0 ? '#5B79AC' : '#A7A7A7')}" stroke="#5B79AC"/>
                          <circle #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{'Consist of' | translate }}" class="cl" cx="24.9612" cy="6.67992" r="5.26" [ngStyle]="{'stroke': card_exp === 1 ? (task?.consistOfTaskPartition?.length != 0 ? '#3ECB79' : '#A7A7A7') : (task?.part_of_count != 0 ? '#3ECB79' : '#A7A7A7')}" stroke="#3ECB79"/>
                          <circle #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{'Related' | translate }}" class="cl" cx="24.9612" cy="29.72" r="5.26" [ngStyle]="{'stroke': card_exp === 1 ? (task?.taskRelated?.length != 0 ? '#FD8C28' : '#A7A7A7') : (task?.related_count != 0 ? '#FD8C28' : '#A7A7A7')}" stroke="#FD8C28"/>
                        </svg>
                      </div>
                        
                      
                      <div class="chat_icon" *ngIf="task?.chatsInfo?.length || (isES && task?.meta?.discussions_count)" (click)="$event.stopPropagation(); openTaskChats(task)">
                        <svg style="width: 43px; height: 40px;" width="45" height="42" viewBox="0 0 45 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.2124 31.7692H7.14286C3.75077 31.7692 1 29.0142 1 25.616L1.00123 7.15446C1.00123 3.75631 3.75077 1 7.14347 1H37.8584C41.2498 1 44 3.75569 44 7.15385V25.616C44 29.0142 41.2498 31.7692 37.8584 31.7692H19.4267C19.4267 36.8658 15.3018 41 10.2149 41V31.7692H10.2124Z" stroke="#1877F2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                          
                        <div class="count">{{ task?.chatsInfo?.length ? task?.chatsInfo?.length : task?.meta?.discussions_count }}</div>
                        <div class="title">{{ "Chats" | translate }}</div>
                        <div class="red_point" *ngIf="task?.unReadChats"></div>
                      </div>
  
                      <div class="notes_count card_notes" (click)="$event.preventDefault(); $event.stopPropagation(); openNotes(task)" *ngIf="task?.documents_count && task?.documents_count > 0">
                        <mat-icon>text_snippet</mat-icon>
                        <span>{{ task?.documents_count }}</span>
                      </div>

                      <div class="task_filesize" *ngIf="task?.filesize && (company?.permissions.includes('owner') || checkIsManager(task, company, user)) && (company | perm:'see_files')" (click)="$event.stopPropagation(); showFilesInterface(task)" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ task?.file_stat_updated_at > 0 ? (task?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3877_49469da)">
                          <path d="M10.9993 4.00033V11.667C10.9993 13.1403 9.80602 14.3337 8.33268 14.3337C6.85935 14.3337 5.66602 13.1403 5.66602 11.667V3.33366C5.66602 2.41366 6.41268 1.66699 7.33268 1.66699C8.25268 1.66699 8.99935 2.41366 8.99935 3.33366V10.3337C8.99935 10.7003 8.69935 11.0003 8.33268 11.0003C7.96602 11.0003 7.66602 10.7003 7.66602 10.3337V4.00033H6.66602V10.3337C6.66602 11.2537 7.41268 12.0003 8.33268 12.0003C9.25268 12.0003 9.99935 11.2537 9.99935 10.3337V3.33366C9.99935 1.86033 8.80602 0.666992 7.33268 0.666992C5.85935 0.666992 4.66602 1.86033 4.66602 3.33366V11.667C4.66602 13.6937 6.30602 15.3337 8.33268 15.3337C10.3593 15.3337 11.9993 13.6937 11.9993 11.667V4.00033H10.9993Z" fill="#6682B4"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_3877_49469da">
                          <rect width="16" height="16" fill="#6682B4"/>
                          </clipPath>
                          </defs>
                        </svg>
                        {{ task?.filesize | filesize }}
                      </div>
                    </div>
                    <ng-template #elseTemplateUP>
                      <div class="up"></div>
                    </ng-template>
                    
  
                    <div class="down" *ngIf="!!task?.meta_channel && !!task?.meta_channel?.task_channels_by_platform_arr && !!task?.meta_channel?.task_channels_by_platform_arr?.length">
                      <div class="profiles_wrp" *ngIf="company | perm:'see_task_channels'">
                        <ng-container *ngFor="let platform of task?.meta_channel?.task_channels_by_platform_arr">
                          <ng-container *ngIf="platform.platform_id">
                            <div class="platform_consolid">
                              <app-platform [ngClass]="{'without_published': !platform.published}" [platform_id]="platform.platform_id"></app-platform>
                              <span 
                              #tooltip="matTooltip"
                              matTooltip="{{ 'All posts + Livestreams' | translate }}"
                              [matTooltipPosition]="'above'"
                              class="post_tab_count all" 
                              *ngIf="((!!platform.published ? 1 : 0) + (!!platform.live ? 1 : 0) + (!!platform.waiting ? 1 : 0)) > 1">{{+platform.published + (+platform?.live || 0) + +platform.waiting}}</span>
                              <span
                              #tooltip="matTooltip"
                              matTooltip="{{ 'Posts that are published or prepared for publishing' | translate }}"
                              [matTooltipPosition]="'above'"
                              class="post_tab_count publ" 
                              *ngIf="platform.published > 0">{{platform.published}}</span>
                              <span 
                              #tooltip="matTooltip"
                              matTooltip="{{ 'Live streaming now' | translate }}"
                              [matTooltipPosition]="'above'"
                              class="post_tab_count live" 
                              *ngIf="platform.live > 0">{{platform.live}}</span>
                              <span    
                              #tooltip="matTooltip"
                              matTooltip="{{ 'Posts that not prepared for publishing. No files assigned to post.' | translate }}"
                              [matTooltipPosition]="'above'"
                              class="post_tab_count wait" 
                              *ngIf="platform.waiting > 0">{{platform.waiting}}</span>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            <ng-template #elseTemplateTASK>
              <div class="container mob_task" (click)="openTask($event, task, i)">
                <div *ngIf="collectionIsActive" class="mob_task_select_btn">
                  <mat-checkbox color="primary" class="example-margin" (click)="$event.stopPropagation()" (change)="$event ? toggleTask(task) : null" [checked]='taskCollection.isSelected(task.id)'></mat-checkbox>
                </div>

                <button class="mob_vert" [ngClass]="{'no_draw': collectionIsActive}" (click)="$event.stopPropagation()" mat-icon-button [matMenuTriggerFor]="mobMenu">
                  <mat-icon style="color: #A3A3A3; vertical-align: baseline;">more_horiz</mat-icon>
                </button>
                <mat-menu #mobMenu="matMenu" xPosition="after">
                  <button mat-menu-item (click)="checkActions($event, task)">
                    <div class="d-f-c">
                      <svg style="margin-right: 15px;" width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.6905 5.47619H12.0476V10.9524L16.7352 13.7343L17.5238 12.409L13.6905 10.131V5.47619ZM13.1429 0C10.5286 0 8.02138 1.03852 6.1728 2.88709C4.32423 4.73566 3.28571 7.24287 3.28571 9.85714H0L4.33714 14.271L8.7619 9.85714H5.47619C5.47619 7.82382 6.28393 5.87377 7.72171 4.43599C9.15948 2.99821 11.1095 2.19048 13.1429 2.19048C15.1762 2.19048 17.1262 2.99821 18.564 4.43599C20.0018 5.87377 20.8095 7.82382 20.8095 9.85714C20.8095 11.8905 20.0018 13.8405 18.564 15.2783C17.1262 16.7161 15.1762 17.5238 13.1429 17.5238C11.029 17.5238 9.11238 16.6586 7.73238 15.2676L6.17714 16.8229C7.96238 18.619 10.4048 19.7143 13.1429 19.7143C15.7571 19.7143 18.2643 18.6758 20.1129 16.8272C21.9615 14.9786 23 12.4714 23 9.85714C23 7.24287 21.9615 4.73566 20.1129 2.88709C18.2643 1.03852 15.7571 0 13.1429 0Z" fill="#000"/>
                      </svg>
                      <span>{{ "Notifications" | translate }}</span>
                    </div>
                  </button>
                  <button mat-menu-item (click)="toShortCut($event, task)">
                    <div class="d-f-c">
                      <svg style="margin-right: 15px;" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 0L5.778 5.004L0 6.516L3.78 11.142L3.438 17.1L9 14.931L14.562 17.1L14.22 11.142L18 6.516L12.222 5.004L9 0ZM6.642 7.2C7.2 7.2 7.65 7.65 7.65 8.217C7.65 8.48434 7.5438 8.74073 7.35476 8.92976C7.16573 9.1188 6.90934 9.225 6.642 9.225C6.075 9.225 5.625 8.775 5.625 8.217C5.625 7.65 6.075 7.2 6.642 7.2ZM11.367 7.2C11.925 7.2 12.375 7.65 12.375 8.217C12.375 8.48434 12.2688 8.74073 12.0798 8.92976C11.8907 9.1188 11.6343 9.225 11.367 9.225C10.8 9.225 10.35 8.775 10.35 8.217C10.35 7.65 10.8 7.2 11.367 7.2ZM6.3 11.25H11.7C11.25 12.339 10.179 13.05 9 13.05C7.821 13.05 6.75 12.339 6.3 11.25Z" fill="#000"/>
                      </svg>
                      <span>{{ "Shortcut" | translate }}</span>
                    </div>
                  </button>
                  <button mat-menu-item (click)="anCardScen(task)">
                    <mat-icon>rebase_edit</mat-icon>
                    <span>{{ 'Set scenario' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="openTagConnection(task)">
                    <mat-icon>account_tree</mat-icon>
                    <span>{{ 'Set card for tag' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="openNotes(task)">
                    <mat-icon>text_snippet</mat-icon> 
                    <span>{{ "Notes" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="openAccessSettings(task)">
                    <mat-icon>settings_applications</mat-icon>
                    <span>{{ "Access Settings" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="showFilesInterface(task)" *ngIf="(company?.permissions.includes('owner') || checkIsManager(task, company, user)) && (company | perm:'see_files')">
                    <mat-icon>perm_media</mat-icon> 
                    <span>{{ "Files" | translate }}</span>
                  </button>
                  <button mat-menu-item *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager') || company?.permissions.includes('assign_task_parameter')" (click)="openTargetValues([task.id, 0, 0], task)">
                    <mat-icon>settings_suggest</mat-icon> 
                    <span>{{ "Tags" | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="migrateTargetFiles(task)" *ngIf="!!user?.is_root">
                    <mat-icon>move_up</mat-icon> 
                    <span>{{ "Migrate all card files" | translate }}</span>
                  </button>
                  <ng-container *ngIf="(company?.permissions.includes('owner') || checkIsManager(task, company, user)) && task?.company_id == company?.id; else elseTemplateBtns">
                    <button mat-menu-item ngxClipboard [cbContent]="origin + '/task/' + task.acm" (cbOnSuccess)="copyLink('Card')">
                      <mat-icon>link</mat-icon> 
                      <span>{{ "Copy card url" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="addWork(task)" *ngIf="company && company?.permissions?.includes('create_task_operation')">
                      <mat-icon>work</mat-icon> 
                      <span>{{ "Add work" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="addProfile(task)" *ngIf="company | perm:'see_task_channels'">
                      <mat-icon>add</mat-icon> 
                      <span>{{ "Add URL to Publication" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="addChannel(task)" *ngIf="company | perm:'see_task_channels'">
                      <mat-icon>add</mat-icon> 
                      <span>{{ "Add Channel" | translate }}</span>
                    </button>
                    <ng-container *ngIf="task.group_id == 0; else elseGroupTemplate">
                      <button mat-menu-item (click)="addGroup(task)">
                        <mat-icon>group</mat-icon> 
                        <span>{{ "Add group" | translate }}</span>
                      </button>
                    </ng-container>
                    <ng-template #elseGroupTemplate>
                      <button mat-menu-item (click)="editGroup(task)">
                        <mat-icon>edit</mat-icon> 
                        <span>{{ "Edit group" | translate }}</span>
                      </button>
                      <!-- <button mat-menu-item (click)="deleteGroup(task)">
                        <mat-icon>delete</mat-icon> 
                        <span>{{ "Delete group" | translate }}</span>
                      </button> -->
                    </ng-template>
                    
                    <button mat-menu-item (click)="goToClients(task)">
                      <mat-icon>group</mat-icon> 
                      <span>{{ "Clients" | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="goToEditTask(task)">
                      <mat-icon>edit</mat-icon> 
                      <span>{{ "Edit" | translate }}</span>
                    </button>
                    <button *ngIf="company?.permissions?.includes('owner') || company?.permissions?.includes('admin')" mat-menu-item (click)="deleteTask(task)">
                      <mat-icon>delete</mat-icon> 
                      <span>{{ "Delete" | translate }}</span>
                    </button>
                  </ng-container>
                  <ng-template #elseTemplateBtns>
                    <button *ngIf="!company?.permissions.includes('client') || task?.company_id != company?.id" mat-menu-item (click)="addEmplWork(task)">
                      <mat-icon>work</mat-icon> 
                      <span>{{ "Add work" | translate }}</span>
                    </button>
                  </ng-template>
                </mat-menu>

                <div class="mob_task_info" >
                  <div class="mob_task_info_left" [ngClass]="{'no_photo': !task?.previewImgs.length && !task?.avatarFile?.thumbnail}">
                    <div class="info_up">
                      <div class="task_status">
                        <!-- {{ task?.status?.name }} -->
                        {{getTaskStatusById(task?.status_id)?.name}}
                      </div>
                      <div class="mob_ids">
                        <div>{{task.custom_id}}</div>
                        <div>{{task.internal_id}}</div>
                        <div class="task_filesize" *ngIf="task.filesize && (company?.permissions.includes('owner') || checkIsManager(task, company, user)) && (company | perm:'see_files')">
                          {{ task.filesize | filesize }}
                        </div>
                      </div>

                      <svg style="cursor: pointer;" class="mob_cons" (click)="$event.stopPropagation(); checkConnections($event, task)" *ngIf="task.consist_of_count != '0' || task.part_of_count != '0' || task.related_count != '0'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z" fill="#D7D7D7"/>
                        <circle *ngIf="task.consist_of_count != 0" cx="6" cy="12" r="3" fill="#96A6C2"/>
                        <circle *ngIf="task.related_count != 0" cx="18" cy="19" r="3" fill="#FFD0A7"/>
                        <circle *ngIf="task.part_of_count != 0" cx="18" cy="5" r="3" fill="#98F1BD"/>
                      </svg>

                      <div class="mob_task_values_wrp ml-c" *ngIf="!!task?.chatsInfo && task.chatsInfo.length">
                        <span class="c_v">{{task?.chatsInfo.length}}</span>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill="rgba(98, 153, 225, 0.6)" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                        </svg>
                      </div>

                      <div class="notes_count card_notes_mob" style="margin-left: 15px;" (click)="$event.preventDefault(); $event.stopPropagation(); openNotes(task)" *ngIf="task?.documents_count && task?.documents_count > 0">
                        <mat-icon>text_snippet</mat-icon>
                        <span>{{ task?.documents_count }}</span>
                      </div>
                    </div>

                    <div class="info_mid">
                      <div class="text_2_line task_title">
                        {{ task.name }}
                      </div>
                    </div>

                    <div class="info_down">
                      <div class="group_name">
                        <ng-container *ngIf="task.group_id; else elseGroupDblTemplate">
                          {{ task?.group?.name || getGroup(task.group_id)?.name }}
                        </ng-container>
                        <ng-template #elseGroupDblTemplate>
                          &nbsp;
                        </ng-template>
                      </div>
                      <div class="mob_dates">
                        <div>
                          <ng-container *ngIf="isES; else elseTemplateESDate">
                            <ng-container *ngIf="task.updated_at > today; else updatedAtTemplES">
                              {{ (task.updated_at*1000 | date:'hh:mm a':'':activeLang) }}
                            </ng-container>
                            <ng-template #updatedAtTemplES>
                              {{ (task.updated_at*1000 | date:'MMM dd, Y':'':activeLang | yearPipe).replaceAll('.', '') }}
                            </ng-template>
                          </ng-container>
                          <ng-template #elseTemplateESDate>        
                            <ng-container *ngIf="task.action_updated_at > today; else updatedAtTempl">
                              {{ (task.action_updated_at*1000 | date:'hh:mm a':'':activeLang) }}
                            </ng-container>
                            <ng-template #updatedAtTempl>
                              {{ (task.action_updated_at*1000 | date:'MMM dd, Y':'':activeLang | yearPipe).replaceAll('.', '') }}
                            </ng-template>
                          </ng-template>
                        </div>
                        <div>
                          <ng-container *ngIf="task.created_at > today; else createdAtTempl">
                            {{ (task.created_at*1000 | date:'hh:mm a':'':activeLang) }}
                          </ng-container>
                          <ng-template #createdAtTempl>
                            {{ (task.created_at*1000 | date:'MMM dd, Y':'':activeLang | yearPipe).replaceAll('.', '') }}
                          </ng-template>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="mob_task_info_right" *ngIf="task?.previewImgs.length || (task?.avatarFile && task?.avatarFile?.thumbnail)">
                    <div class="mob_preview_wrp" >
                      <swiper [ngClass]="{'p-b': task?.previewImgs.length > 1 || (task?.avatarFile && task?.avatarFile?.thumbnail)}" [pagination]="false" [navigation]="false">
                        <ng-container *ngIf="task?.previewImgs.length > 0 && task?.custom_avatar_property == ''; else elseTemplateHasPreview">
                          <ng-container *ngFor="let preview of task?.previewImgs">
                            <ng-template swiperSlide>
                              <div class="preview_img" [lazyLoad]="(!preview.is_parser_url ? host : '') + preview.src"></div>
                            </ng-template>
                          </ng-container>
                        </ng-container>
                        <ng-template #elseTemplateHasPreview>
                          <ng-template swiperSlide>
                            <div class="preview_img" [lazyLoad]="host + task?.avatarFile?.thumbnail + '?company_id=' + company?.id"></div>
                          </ng-template>
                        </ng-template>
                      </swiper>
                    </div>
                  </div>
                </div>

                <!-- 'margin-right': (op?.statuses.slice(1).length > 0 ? (21 + op?.statuses.slice(1).length*5) : 7) + 'px', -->
                <div class="mob_task_jobs_wrp">
                  <ng-container *ngIf="!!isES; else elseTemplateISES">
                    <div class="mob_task_jobs" *ngIf="task?.meta?.task_operations_by_operation_arr.length;">
                      <div class="job_out" *ngFor="let op of task?.meta?.task_operations_by_operation_arr; let u = index;" [ngStyle]="{'margin-right': (op?.by_status_arr.slice(1).length > 0 ? (17.5 + (op?.by_status_arr.slice(1).length - 1)*5) : 3.5) + 'px', 'width': 81 + (op?.executors.length > 3 ? 3*15 : (op?.executors.length - 1)*15) + 'px', 'min-width': 81 + (op?.executors.length > 3 ? 3*15 : (op?.executors.length - 1)*15) + 'px'}">
                        <div class="job" [ngClass]="{
                          'first': op?.by_status_arr[0]?.status_id == '1',
                          'second': op?.by_status_arr[0]?.status_id == '2',
                          'third': op?.by_status_arr[0]?.status_id == '3',
                          'fours': op?.by_status_arr[0]?.status_id == '4',
                          'fives': op?.by_status_arr[0]?.status_id == '5',
                          'sixs': op?.by_status_arr[0]?.status_id == '6',
                          'nine': op?.by_status_arr[0]?.status_id == '97',
                          'seven': op?.by_status_arr[0]?.status_id == '98',
                          'eight': op?.by_status_arr[0]?.status_id == '99'
                        }">
                          <div class="employees" *ngIf="op?.executors.length">
                            <ng-container *ngIf="op?.executors.length > 3;">
                              <div class="plus">
                                +{{op?.executors.length - 3}}
                              </div>
                            </ng-container>
    
                            <div class="more_empls">
                              <ng-container *ngFor="let item of op?.executors; let u = index;">
                                <ng-container *ngIf="u <= 2">
                                  <ng-container *ngIf="item?.is_partner; else elsePartner">
                                    <ng-container *ngIf="!!getPartnerById(item?.id)?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                      <img [appHoverUserInfo]="{ user: {partnerCompany: getPartnerById(item?.id)}, company_id: company?.id }" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}"
                                      matTooltip="{{getPartnerById(item?.id)?.name}}"
                                      [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + getPartnerById(item?.id)?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                                    </ng-container>
                                    <ng-template #elseTemplatePartnerAvatar>
                                      <img [appHoverUserInfo]="{ user: {partnerCompany: getPartnerById(item?.id)}, company_id: company?.id }" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}"
                                      matTooltip="{{getPartnerById(item?.id)?.name}}"
                                      [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                                    </ng-template>
                                  </ng-container>
                                  <ng-template #elsePartner>
                                    <ng-container *ngIf="getEmployeeById(item?.id)?.image; else elseMobWorkTemplate">
                                      <img [appHoverUserInfo]="{ user: getEmployeeById(item?.id), company_id: company?.id }" #tooltip="matTooltip" 
                                      matTooltip="{{getEmployeeById(item?.id)?.name}}"
                                      [matTooltipPosition]="'above'" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" [src]="getEmployeeById(item?.id)?.image" alt="" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}">
                                    </ng-container>
                                    <ng-template #elseMobWorkTemplate>
                                      <mat-icon [appHoverUserInfo]="{ user: getEmployeeById(item?.id), company_id: company?.id }" [ngClass]="{'no_bor': op?.executors.length <= 3 && u == op?.executors.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.executors.length - u, 'right': ((op?.executors.length > 3 ? 45 : (15*(op?.executors.length - 1))) - u*15) + 'px'}"
                                      matTooltip="{{getEmployeeById(item?.id)?.name}}"
                                      [matTooltipPosition]="'above'">account_circle</mat-icon>
                                    </ng-template>
                                  </ng-template>
                                </ng-container>      
                              </ng-container>
                            </div>
                          </div>
                          <span class="text_2_line">
                            {{ getJobTypeById(op.operation_id)?.name }}
                          </span>
                          <div class="circles" *ngIf="op?.by_status_arr.slice(1).length > 0">
                            <div class="circle" *ngFor="let item of op?.by_status_arr.slice(1); let j = index;" [ngClass]="{
                              'first': item.status_id == '1',
                              'second': item.status_id == '2',
                              'third': item.status_id == '3',
                              'fours': item.status_id == '4',
                              'fives': item.status_id == '5',
                              'sixs': item.status_id == '6',
                              'nine': item.status_id == '97',
                              'seven': item.status_id == '98',
                              'eight': item.status_id == '99'
                            }" 
                            [ngStyle]="{'z-index': op.by_status_arr.length - j, 'right': '-' + (14 + j*5) + 'px'}"
                            >
                            <ng-container *ngIf="op.count >= 2 && j == 0">{{op.count - 1}}</ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="task?.meta?.task_operations_by_operation_arr.length <= 2">
                      <ng-container *ngTemplateOutlet="elseTemplateMobProfiles"></ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #elseTemplateISES>
                    <div class="mob_task_jobs" *ngIf="task?.worksByTypeAndStatus.length;">
                      <div class="job_out" *ngFor="let op of task?.worksByTypeAndStatus; let u = index;" [ngStyle]="{'margin-right': (op?.statuses.slice(1).length > 0 ? (17.5 + (op?.statuses.slice(1).length - 1)*5) : 3.5) + 'px', 'width': 81 + (op.allEmpl.length > 3 ? 3*15 : (op.allEmpl.length - 1)*15) + 'px', 'min-width': 81 + (op.allEmpl.length > 3 ? 3*15 : (op.allEmpl.length - 1)*15) + 'px'}">
                        <div class="job" [ngClass]="{
                          'first': op?.statuses[0]?.name == '1',
                          'second': op?.statuses[0]?.name == '2',
                          'third': op?.statuses[0]?.name == '3',
                          'fours': op?.statuses[0]?.name == '4',
                          'fives': op?.statuses[0]?.name == '5',
                          'sixs': op?.statuses[0]?.name == '6',
                          'nine': op?.statuses[0]?.name == '97',
                          'seven': op?.statuses[0]?.name == '98',
                          'eight': op?.statuses[0]?.name == '99'
                        }">
                          <div class="employees" *ngIf="op?.allEmpl.length">
                            <ng-container *ngIf="op?.allEmpl.length > 3;">
                              <div class="plus">
                                +{{op?.allEmpl.length - 3}}
                              </div>
                            </ng-container>
    
                            <div class="more_empls">
                              <ng-container *ngFor="let item of op?.allEmpl; let u = index;">
                                <ng-container *ngIf="u <= 2">
                                  <ng-container *ngIf="item?.employee?.image; else elseMobWorkTemplate">
                                    <img [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" #tooltip="matTooltip" 
                                    matTooltip="{{item?.employee?.name}}"
                                    [matTooltipPosition]="'above'" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" [src]="item?.employee?.image" alt="" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}">
                                  </ng-container>
                                  <ng-template #elseMobWorkTemplate>
                                    <ng-container *ngIf="item?.is_partner; else elsePartner">
                                      <ng-container *ngIf="!!item?.partnerCompany?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                        <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}"
                                        matTooltip="{{item?.partnerCompany?.name}}"
                                        [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + item?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                                      </ng-container>
                                      <ng-template #elseTemplatePartnerAvatar>
                                        <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}"
                                        matTooltip="{{item?.partnerCompany?.name}}"
                                        [matTooltipPosition]="'above'" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                                      </ng-template>
                                    </ng-container>
                                    <ng-template #elsePartner>
                                      <mat-icon [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" [ngClass]="{'no_bor': op?.allEmpl.length <= 3 && u == op?.allEmpl.length - 1}" #tooltip="matTooltip" [ngStyle]="{'z-index': op?.allEmpl.length - u, 'right': ((op?.allEmpl.length > 3 ? 45 : (15*(op?.allEmpl.length - 1))) - u*15) + 'px'}"
                                      matTooltip="{{item?.employee?.name}}"
                                      [matTooltipPosition]="'above'">account_circle</mat-icon>
                                    </ng-template>
                                  </ng-template>
                                </ng-container>      
                              </ng-container>
                            </div>
                          </div>
                          <span class="text_2_line">
                            {{ op.type }}
                          </span>
                          <div class="circles" *ngIf="op?.statuses.slice(1).length > 0">
                            <div class="circle" *ngFor="let item of op?.statuses.slice(1); let j = index;" [ngClass]="{
                              'first': item.name == '1',
                              'second': item.name == '2',
                              'third': item.name == '3',
                              'fours': item.name == '4',
                              'fives': item.name == '5',
                              'sixs': item.name == '6',
                              'nine': item.name == '97',
                              'seven': item.name == '98',
                              'eight': item.name == '99'
                            }" 
                            [ngStyle]="{'z-index': op.statuses.length - j, 'right': '-' + (14 + j*5) + 'px'}"
                            >
                            <ng-container *ngIf="op.count >= 2 && j == 0">{{op.count - 1}}</ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="task?.worksByTypeAndStatus.length <= 2">
                      <ng-container *ngTemplateOutlet="elseTemplateMobProfiles"></ng-container>
                    </ng-container>
                  </ng-template>
                  
                </div>

                <div class="mob_task_footer">
                  <div class="comments" [ngClass]="{'full': (!isES && task?.worksByTypeAndStatus.length <= 2) || (!!isES && task?.meta?.task_operations_by_operation_arr.length <= 2)}">
                    <div class="mob_task_comment" [innerHTML]='task?.comment ? task?.comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' [ngClass]="{'text_one_line': task?.private_comment, 'text_2_line': !task?.private_comment}">
                    </div>
                    <div class="mob_task_comment private" [innerHTML]='task?.private_comment ? task?.private_comment.replaceAll("\n"," ").replaceAll("<br>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("</BR>"," ") : ""' [ngClass]="{'text_one_line': task?.comment, 'text_2_line': !task?.comment}">   
                    </div>
                  </div>
                  <ng-container *ngIf="(!isES && task?.worksByTypeAndStatus.length > 2) || (!!isES && task?.meta?.task_operations_by_operation_arr.length > 2)">
                    <ng-container *ngTemplateOutlet="elseTemplateMobProfiles"></ng-container>
                  </ng-container>
                </div>
                <!-- <div class="mob_task_private text_one_line" [innerHTML]="task.private_comment | linky:{newWindow: true}"></div> -->
              </div>
              <ng-template #elseTemplateMobProfiles>
                <div class="mob_profiles" *ngIf="company | perm:'see_task_channels'">
                  <div class="profiles_wrp">
                    <ng-container *ngFor="let platform of task?.meta_channel?.task_channels_by_platform_arr; let ind = index;">
                      <ng-container *ngIf="platform.platform_id">
                        <!-- <div *ngIf="!!platform.published" class="plat_meta published">
                          <app-platform [platform_id]="platform.platform_id"></app-platform>
                          <span>{{platform.published}}</span>
                        </div>
                        <div *ngIf="!!platform.live" class="plat_meta live">
                          <app-platform [platform_id]="platform.platform_id"></app-platform>
                          <span *ngIf="platform.live > 1">{{platform.live}}</span>
                        </div>
                        <div *ngIf="!!platform.waiting" class="plat_meta waiting">
                          <app-platform [platform_id]="platform.platform_id"></app-platform>
                          <span>{{platform.waiting}}</span>
                        </div> -->
                        <div class="platform_consolid">
                          <app-platform [ngClass]="{'without_published': !platform.published}" [platform_id]="platform.platform_id"></app-platform>
                          <span 
                          #tooltip="matTooltip"
                          matTooltip="{{ 'All posts + Livestreams' | translate }}"
                          [matTooltipPosition]="'above'"
                          class="post_tab_count all" 
                          *ngIf="((!!platform.published ? 1 : 0) + (!!platform.live ? 1 : 0) + (!!platform.waiting ? 1 : 0)) > 1">{{+platform.published + (+platform?.live || 0) + +platform.waiting}}</span>
                          <span
                          #tooltip="matTooltip"
                          matTooltip="{{ 'Posts that are published or prepared for publishing' | translate }}"
                          [matTooltipPosition]="'above'"
                          class="post_tab_count publ" 
                          *ngIf="platform.published > 0">{{platform.published}}</span>
                          <span 
                          #tooltip="matTooltip"
                          matTooltip="{{ 'Live streaming now' | translate }}"
                          [matTooltipPosition]="'above'"
                          class="post_tab_count live" 
                          *ngIf="platform.live > 0">{{platform.live}}</span>
                          <span    
                          #tooltip="matTooltip"
                          matTooltip="{{ 'Posts that not prepared for publishing. No files assigned to post.' | translate }}"
                          [matTooltipPosition]="'above'"
                          class="post_tab_count wait" 
                          *ngIf="platform.waiting > 0">{{platform.waiting}}</span>
                        </div>
                      </ng-container>
                      <!-- <div class="profiles_more" *ngIf="ind == task?.channels.length - 1 && ind > 3">
                        +{{ task?.channels.length - 4}}
                      </div> -->
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </ng-template>
        </div>
      </div>
  
    <div class="container btns_line_wrp" *ngIf="is_mobile">
      <div class="btns_line" [ngClass]="{'paddings_block': !!tasks?.length}">
          <div *ngIf="!is_mobile" class="d-f-c">
            <button mat-raised-button href="" [routerLink]="['/main']">
                {{ "Back" | translate }}
            </button>
            <ng-container *ngIf="!company?.permissions.includes('client') && company && company?.permissions?.includes('create_task')">
              <ng-container *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager'); else elseTaskCreateTemplate">
                <button class="ml-1" (click)="createTask()" mat-raised-button color="primary">
                  <mat-icon>add</mat-icon>
                  {{ "Create task" | translate }}
                </button>
              </ng-container>
              <ng-template #elseTaskCreateTemplate>
                <button class="ml-1" (click)="emplCreateTask()" mat-raised-button color="primary">
                  <mat-icon>add</mat-icon>
                  {{ "Create task" | translate }}
                </button>
              </ng-template>
            </ng-container>
  
            <button [matMenuTriggerFor]="multiMenu" class="ml-1" *ngIf="taskCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))" mat-raised-button color="warn">
              {{taskCollection?.selected?.length}}
              <mat-icon>settings</mat-icon>
            </button>
            <mat-menu #multiMenu="matMenu" xPosition="after">
              <button mat-menu-item (click)="multiEditTaskStatus()">
                <mat-icon>edit</mat-icon> 
                <span>{{ "Edit" | translate }} {{taskCollection?.selected?.length}} {{ 'task(s)' | translate }} {{ "statuses" | translate }}</span>
              </button>
              <button (click)="addMultiWorks()" mat-menu-item>
                <mat-icon>add</mat-icon>
                {{ "Add job to" | translate }} {{taskCollection?.selected?.length}} {{ 'task(s)' | translate }}
              </button>
            </mat-menu>
              
          </div>
  
          <div class="d-f">
            <div class="info mr-1">
              <b *ngIf="!is_mobile">{{ "Cards" | translate }}:</b>
              <b *ngIf="is_mobile">{{ "Total" | translate }}:</b>
              <span class="cp" (click)="getTasksCount()">
                <ng-container *ngIf="!!totalTasksCount; else elseTemplatetotalTasksCount">
                  {{totalTasksCount}}
                </ng-container>
                <ng-template #elseTemplatetotalTasksCount>
                  {{ tasks?.length }}<ng-container *ngIf="hasMore">+</ng-container>
                </ng-template>
              </span>
            </div>
            <ng-container *ngIf="!!is_mobile">
              <mat-slide-toggle (change)="selectChangeEs($event)"
                  class="mr-1"
                  [color]="'primary'"
                  [(ngModel)]="isES">
                V2
              </mat-slide-toggle>
            </ng-container>
            <div class="total_block">
              <div>
                <b *ngIf="!is_mobile">{{ "Points" | translate }}:</b> 
                <span>
                  {{ totalInfo['summaryRate'] | reportsNumber }}
                </span>
                <span *ngIf="is_mobile">pts</span>
              </div>
              <div>
                <b *ngIf="!is_mobile">{{ "Amount" | translate }}:</b> 
                <span *ngFor="let cPrice of totalInfo['summaryPrice']; let i = index">
                  <ng-container *ngIf="cPrice.summary != '0'">
                    <ng-container [ngSwitch]="cPrice.currency_id">
                      <ng-container *ngSwitchCase="'1'">&#36;</ng-container>
                      <ng-container *ngSwitchCase="'2'">&#8381;</ng-container>
                      <ng-container *ngSwitchCase="'3'">&#8364;</ng-container>
                      <ng-container *ngSwitchCase="'4'">&#8372;</ng-container>
                    </ng-container>{{ cPrice.summary | reportsNumber }}
                    <ng-container *ngIf="i < totalInfo['summaryPrice'].length - 1">
                      &nbsp;
                    </ng-container> 
                  </ng-container>             
                </span>
              </div>
            </div>
          </div>
      </div>
  </div>
  
  <ng-template #taskMenu let-val>
    <section class="file-menu">
      <div [innerHTML]="val | linky:{newWindow: true}"></div>
    </section>
  </ng-template>

  <ng-template #cardContext let-task>
    <section class="card-menu">
      <!-- <div [innerHTML]="val | linky:{newWindow: true}"></div> -->
      <div (click)="closeCardContext(); openInNew(task)">
        <mat-icon>open_in_new</mat-icon> 
        <span>{{ "Open in new tab" | translate }}</span>
      </div>
      <div (click)="closeCardContext(); showFilesInterface(task)" *ngIf="(company?.permissions.includes('owner') || checkIsManager(task, company, user)) && (company | perm:'see_files')">
        <mat-icon>perm_media</mat-icon> 
        <span>{{ "Files" | translate }}</span>
      </div>
      <div (click)="closeCardContext(); anCardScen(task)">
        <mat-icon>rebase_edit</mat-icon>
        <span>{{ 'Set scenario' | translate }}</span>
      </div>
      <div (click)="closeCardContext(); openTagConnection(task)">
        <mat-icon>account_tree</mat-icon>
        <span>{{ 'Set card for tag' | translate }}</span>
      </div>
      <div (click)="closeCardContext(); openNotes(task)">
        <mat-icon>text_snippet</mat-icon>
        <span>{{ 'Notes' | translate }}</span>
      </div>
      <div (click)="closeCardContext(); openAccessSettings(task)">
        <mat-icon>settings_applications</mat-icon>
        <span>{{ "Access Settings" | translate }}</span>
      </div>
      <!-- <div (click)="closeCardContext(); addNote(task)">
        <mat-icon>playlist_add_circle</mat-icon>
        <span>{{ 'Add Note' | translate }}</span>
      </div> -->
      <div (click)="closeCardContext(); toShortCut($event, task)">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 0L5.778 5.004L0 6.516L3.78 11.142L3.438 17.1L9 14.931L14.562 17.1L14.22 11.142L18 6.516L12.222 5.004L9 0ZM6.642 7.2C7.2 7.2 7.65 7.65 7.65 8.217C7.65 8.48434 7.5438 8.74073 7.35476 8.92976C7.16573 9.1188 6.90934 9.225 6.642 9.225C6.075 9.225 5.625 8.775 5.625 8.217C5.625 7.65 6.075 7.2 6.642 7.2ZM11.367 7.2C11.925 7.2 12.375 7.65 12.375 8.217C12.375 8.48434 12.2688 8.74073 12.0798 8.92976C11.8907 9.1188 11.6343 9.225 11.367 9.225C10.8 9.225 10.35 8.775 10.35 8.217C10.35 7.65 10.8 7.2 11.367 7.2ZM6.3 11.25H11.7C11.25 12.339 10.179 13.05 9 13.05C7.821 13.05 6.75 12.339 6.3 11.25Z" fill="#686868"/>
        </svg>
        <span>{{ "Shortcut" | translate }}</span>
      </div>
      <div (click)="closeCardContext(); addProfile(task)" *ngIf="company | perm:'see_task_channels'">
        <mat-icon>add</mat-icon> 
        <span>{{ "Add URL to Publication" | translate }}</span>
      </div>
      <div (click)="closeCardContext(); migrateTargetFiles(task)" *ngIf="!!user?.is_root">
        <mat-icon>move_up</mat-icon> 
        <span>{{ "Migrate all card files" | translate }}</span>
      </div>
      <div (click)="closeCardContext(); addChannel(task)" *ngIf="company | perm:'see_task_channels'">
        <mat-icon>add</mat-icon> 
        <span>{{ "Add Channel" | translate }}</span>
      </div>
      <div *ngIf="company?.permissions.includes('owner') || company?.permissions.includes('admin') || company?.permissions.includes('manager') || company?.permissions.includes('assign_task_parameter')" (click)="closeCardContext(); openTargetValues([task.id, 0, 0], task)">
        <mat-icon>settings_suggest</mat-icon> 
        <span>{{ "Tags" | translate }}</span>
      </div>
      <ng-container *ngIf="(company?.permissions.includes('owner') || checkIsManager(task, company, user)) && task?.company_id == company?.id; else elseTemplateBtns">
        <div ngxClipboard [cbContent]="origin + '/task/' + task.acm" (cbOnSuccess)="copyLink('Card'); closeCardContext();">
          <mat-icon>link</mat-icon> 
          <span>{{ "Copy card url" | translate }}</span>
        </div>
        <div (click)="closeCardContext(); addWork(task)" *ngIf="company && company?.permissions?.includes('create_task_operation')">
          <mat-icon>work</mat-icon> 
          <span>{{ "Add work" | translate }}</span>
        </div>
        <div (click)="closeCardContext(); moveAllJobs(task)">
          <mat-icon>move_down</mat-icon> 
          <span>{{ "Move All Jobs" | translate }}</span>
        </div>
        <div (click)="closeCardContext(); taskManagers(task)">
          <mat-icon>manage_accounts</mat-icon> 
          <span>{{ "Task managers" | translate }}</span>
        </div>
        <ng-container *ngIf="task.group_id == 0; else elseGroupTemplate">
          <div (click)="closeCardContext(); addGroup(task)">
            <mat-icon>group</mat-icon> 
            <span>{{ "Add group" | translate }}</span>
          </div>
        </ng-container>
        <ng-template #elseGroupTemplate>
          <div (click)="closeCardContext(); editGroup(task)">
            <mat-icon>edit</mat-icon> 
            <span>{{ "Edit group" | translate }}</span>
          </div>
          <!-- <div (click)="closeCardContext(); deleteGroup(task)">
            <mat-icon>delete</mat-icon> 
            <span>{{ "Delete group" | translate }}</span>
          </div> -->
        </ng-template>
        
        <div (click)="closeCardContext(); goToClients(task)">
          <mat-icon>group</mat-icon> 
          <span>{{ "Clients" | translate }}</span>
        </div>
        <div (click)="closeCardContext(); goToEditTask(task)">
          <mat-icon>edit</mat-icon> 
          <span>{{ "Edit" | translate }}</span>
        </div>
        <div *ngIf="company?.permissions?.includes('owner') || company?.permissions?.includes('admin')" (click)="closeCardContext(); deleteTask(task)">
          <mat-icon>delete</mat-icon> 
          <span>{{ "Delete" | translate }}</span>
        </div>
      </ng-container>
      <ng-template #elseTemplateBtns>
        <div *ngIf="!company?.permissions.includes('client') || task?.company_id != company?.id" (click)="closeCardContext(); addEmplWork(task)">
          <mat-icon>work</mat-icon> 
          <span>{{ "Add work" | translate }}</span>
        </div>
      </ng-template>
    </section>
  </ng-template>
  
    <!-- Tags filter -->
  <!-- <ng-template #filterParameterMenu let-val>
    <section class="task_executor_filter">
      <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs">
        <mat-tab>
            <ng-template mat-tab-label>
                {{ "For task" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
              <ng-container *ngFor="let param of parameters">

                <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                    <mat-label>{{ param.name }}</mat-label>
        
                    <mat-chip-list 
                        class="without_ordered"
                        #paramsChipList
                        formControlName="task_parameter_value_id"
                    >
                        <mat-chip 
                            class="param_chip_on_page"
                            *ngFor="let val of param.activeTaskValues; let k = index;"
                            [removable]="true" 
                            color="primary" 
                            (removed)="onRemove(val, param, 'task_parameter_value_id')">
                                {{ getValueById(val.id)?.value }} <span class="parameter_name" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
        
                        <input
                        id="param_input_{{param.id}}"
                        class="auto_complete_input"
                        placeholder="{{ 'Search' | translate }}"
                        #paramsInput
                        [formControl]="param.search"
                        [matAutocomplete]="paramsAuto"
                        [matChipInputFor]="paramsChipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete class="filter_autocomlete" autoActiveFirstOption #paramsAuto="matAutocomplete" (optionsScroll)="onScrollParams(param)" (optionSelected)="selected($event, param, 'task_parameter_value_id')">
                        <ng-container *ngFor="let val of param.values">
                            <mat-option *ngIf="noOption(param.activeTaskValues, val.id) && withSearch(param?.search?.value, val)" [value]="val">
                              <div class="d-f-c" style="justify-content: space-between;">
                                <span>
                                  {{ val.value }}
                                </span>
                                <span class="parameter_name_in_option" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                              </div>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-form-field>
              </ng-container>
            </form>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                {{ "For Job" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
              <ng-container *ngFor="let param of parameters">

                <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                    <mat-label>{{ param.name }}</mat-label>
        
                    <mat-chip-list 
                        class="without_ordered"
                        #paramsChipList
                        formControlName="task_operation_parameter_value_id"
                    >
                        <mat-chip 
                            class="param_chip_on_page"
                            *ngFor="let val of param.activeJobValues; let k = index;"
                            [removable]="true" 
                            color="primary" 
                            (removed)="onRemove(val, param, 'task_operation_parameter_value_id')">
                                {{ getValueById(val.id)?.value }} <span class="parameter_name" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
        
                        <input
                        id="param_input_{{param.id}}"
                        class="auto_complete_input"
                        placeholder="{{ 'Search' | translate }}"
                        #paramsInput
                        [formControl]="param.search"
                        [matAutocomplete]="paramsAuto"
                        [matChipInputFor]="paramsChipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete class="filter_autocomlete" autoActiveFirstOption #paramsAuto="matAutocomplete" (optionsScroll)="onScrollParams(param)" (optionSelected)="selected($event, param, 'task_operation_parameter_value_id')">
                        <ng-container *ngFor="let val of param.values">
                            <mat-option *ngIf="noOption(param.activeJobValues, val.id) && withSearch(param?.search?.value, val)" [value]="val">
                              <div class="d-f-c" style="justify-content: space-between;">
                                <span>
                                  {{ val.value }}
                                </span>
                                <span class="parameter_name_in_option" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                              </div>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-form-field>
              </ng-container>
            </form>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                {{ "For Chat" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
              <ng-container *ngFor="let param of parameters">

                <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                    <mat-label>{{ param.name }}</mat-label>
        
                    <mat-chip-list 
                        class="without_ordered"
                        #paramsChipList
                        formControlName="discussion_parameter_value_id"
                    >
                        <mat-chip 
                            class="param_chip_on_page"
                            *ngFor="let val of param.activeDiscussionValues; let k = index;"
                            [removable]="true" 
                            color="primary" 
                            (removed)="onRemove(val, param, 'discussion_parameter_value_id')">
                                {{ getValueById(val.id)?.value }} <span class="parameter_name" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
        
                        <input
                        id="param_input_{{param.id}}"
                        class="auto_complete_input"
                        placeholder="{{ 'Search' | translate }}"
                        #paramsInput
                        [formControl]="param.search"
                        [matAutocomplete]="paramsAuto"
                        [matChipInputFor]="paramsChipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete class="filter_autocomlete" autoActiveFirstOption #paramsAuto="matAutocomplete" (optionsScroll)="onScrollParams(param)" (optionSelected)="selected($event, param, 'discussion_parameter_value_id')">
                        <ng-container *ngFor="let val of param.values">
                            <mat-option *ngIf="noOption(param.activeDiscussionValues, val.id) && withSearch(param?.search?.value, val)" [value]="val">
                              <div class="d-f-c" style="justify-content: space-between;">
                                <span>
                                  {{ val.value }}
                                </span>
                                <span class="parameter_name_in_option" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                              </div>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-form-field>
              </ng-container>
            </form>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                {{ "For all" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in parameter_filter scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
              <ng-container *ngFor="let param of parameters">

                <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                    <mat-label>{{ param.name }}</mat-label>
        
                    <mat-chip-list 
                        class="without_ordered"
                        #paramsChipList
                        formControlName="parameter_value_id"
                    >
                        <mat-chip 
                            class="param_chip_on_page"
                            *ngFor="let val of param.activeValues; let k = index;"
                            [removable]="true" 
                            color="primary" 
                            (removed)="onRemove(val, param, 'parameter_value_id')">
                                {{ getValueById(val.id)?.value }} <span class="parameter_name" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
        
                        <input
                        id="all_param_input_{{param.id}}"
                        class="auto_complete_input"
                        placeholder="{{ 'Search' | translate }}"
                        #paramsInput
                        [formControl]="param.search"
                        [matAutocomplete]="paramsAuto"
                        [matChipInputFor]="paramsChipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete class="filter_autocomlete" autoActiveFirstOption #paramsAuto="matAutocomplete" (optionsScroll)="onScrollParams(param)" (optionSelected)="selected($event, param, 'parameter_value_id')">
                        <ng-container *ngFor="let val of param.values">
                            <mat-option *ngIf="noOption(param.activeValues, val.id) && withSearch(param?.search?.value, val)" [value]="val">
                              <div class="d-f-c" style="justify-content: space-between;">
                                <span>
                                  {{ val.value }}
                                </span>
                                <span class="parameter_name_in_option" *ngIf="param.id == 0 && getParameterById(val.parameter_id)">({{ getParameterById(val.parameter_id).name }})</span> 
                              </div>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-form-field>
              </ng-container>
            </form>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-template> -->

    <!-- Executors filter -->
  <!-- <ng-template #filterExecMenu let-val>
    <section class="task_executor_filter">
      <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs" [selectedIndex]="selectedExecIndex" (selectedIndexChange)="changeTab($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                {{ "Own executors" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">

              <div class="filter_task_search">
                <mat-form-field appearance="legacy" class="filter_form search">
                  <mat-icon matPrefix>search</mat-icon>
                  <input [formControl]="execControl" matInput>
                </mat-form-field>
              </div>

              <mat-selection-list [multiple]="false" formControlName="operation_employee_id" (selectionChange)="selectChange($event)">
                <mat-list-option [value]="0">{{ "No executor" | translate }}</mat-list-option>
                <mat-list-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                  <app-user [class]="'user_div'" [employee]="employee"></app-user>
                </mat-list-option>
              </mat-selection-list>
            </form>
        </mat-tab>
        <mat-tab *ngIf="!!partners && !!partners.length">
            <ng-template mat-tab-label>
                {{ "External executors" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">

              <div class="filter_task_search">
                <mat-form-field appearance="legacy" class="filter_form search">
                  <mat-icon matPrefix>search</mat-icon>
                  <input [formControl]="partnersControl" matInput>
                </mat-form-field>
              </div>
              
              <mat-selection-list [multiple]="false" formControlName="operation_partner_company_id" (selectionChange)="selectChange($event)">
                <mat-list-option *ngFor="let partner of partners$ | async" [value]="partner.partner_company_id">
                  <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                </mat-list-option>
              </mat-selection-list>
            </form>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-template> -->

  <!-- Client filter -->
  <!-- <ng-template #filterClientMenu let-val>
    <section class="task_executor_filter">
      <mat-tab-group mat-align-tabs="center" class="create_new_task_tabs">
        <mat-tab>
            <ng-template mat-tab-label>
                {{ "Users" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">
              <div class="filter_task_search">
                <mat-form-field appearance="legacy" class="filter_form search">
                  <mat-icon matPrefix>search</mat-icon>
                  <input [formControl]="clientControl" matInput>
                </mat-form-field>
              </div>

              <mat-selection-list [multiple]="false" (selectionChange)="changeSelectionList($event, 'client_employee_id')">
                <mat-list-option *ngFor="let employee of employees$ | async" [selected]="employee.id == filter.get('client_employee_id').value" [value]="employee.id">
                  <app-user [class]="'user_div'" [employee]="employee"></app-user>
                </mat-list-option>
              </mat-selection-list>
            </form>
        </mat-tab>
        <mat-tab *ngIf="!!partners">
            <ng-template mat-tab-label>
                {{ "Workspaces" | translate }}
            </ng-template>

            <form [formGroup]="filter" class="filter_in scroll_task_filter" [appDeviceClass]="'custom-scroll'" (ngSubmit)="filterTasks(null, null, true)">

              <div class="filter_task_search">
                <mat-form-field appearance="legacy" class="filter_form search">
                  <mat-icon matPrefix>search</mat-icon>
                  <input [formControl]="partnersControl" matInput>
                </mat-form-field>
              </div>
              
              <mat-selection-list [multiple]="false" (selectionChange)="changeSelectionList($event, 'task_company_id')">
                <mat-list-option *ngFor="let partner of partners$ | async" [selected]="partner.partner_company_id == filter.get('task_company_id').value" [value]="partner.partner_company_id">
                  <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                </mat-list-option>
              </mat-selection-list>
            </form>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-template> -->

  <!-- <ng-template #filterMenu let-val>
    <section class="search_params">
      <form [formGroup]="filter" class="params_form" (ngSubmit)="filterTasks(null, null, true)" >
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card Title" | translate }}</mat-label>
          <input matInput formControlName="q_task_name">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card description" | translate }}</mat-label>
          <input matInput formControlName="q_task_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card private comment" | translate }}</mat-label>
          <input matInput formControlName="q_task_private_comment">
        </mat-form-field>
        <div class="d-f-c search-field-group">
          <mat-form-field class="search-field" appearance="legacy">
            <mat-label>{{ "Card custom ID" | translate }}</mat-label>
            <input type="number" matInput formControlName="task_custom_id">
          </mat-form-field>
          <mat-form-field class="search-field ml-1" appearance="legacy">
            <mat-label>{{ "Card internal ID" | translate }}</mat-label>
            <input type="number" matInput formControlName="internal_id">
          </mat-form-field>
          <mat-form-field class="search-field ml-1" appearance="legacy">
            <mat-label>{{ "Card system ID" | translate }}</mat-label>
            <input type="number" matInput formControlName="id">
          </mat-form-field>
        </div>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Card workspace ID" | translate }}</mat-label>
          <input type="number" matInput formControlName="task_company_id">
        </mat-form-field>
        
        <div style="padding-top: 30px;"></div>
        
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job title" | translate }}</mat-label>
          <input matInput formControlName="q_task_operation_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job executor commment" | translate }}</mat-label>
          <input matInput formControlName="q_task_operation_employee_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job private comment " | translate }}</mat-label>
          <input matInput formControlName="q_task_operation_private_comment">
        </mat-form-field>
        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Job System ID " | translate }}</mat-label>
          <input type="number" matInput formControlName="task_operation_id">
        </mat-form-field>

        <div style="padding-top: 30px;"></div>

        <mat-form-field class="search-field" appearance="legacy">
          <mat-label>{{ "Chat system ID" | translate }}</mat-label>
          <input type="number" matInput formControlName="discussion_id">
        </mat-form-field>

        <div class="d-f-c" style="padding-top: 20px; justify-content: flex-end;">
          
          <button mat-button type="button" (click)="closeOpenFilter()">{{ "Close" | translate }}</button>
          <button mat-raised-button color="warn" (click)="resetSearchParams()" type="button" class="ml-1">{{ "Clear" | translate }}</button>
          <button mat-raised-button color="primary" type="submit" class="ml-1">{{ "Search" | translate }}</button>
        </div>
      </form>
    </section>
</ng-template> -->

  <!-- <app-loader-more *ngIf="isLoad"></app-loader-more> -->
  <mat-progress-bar mode="indeterminate" *ngIf="isLoad" class="mat_proggress_w8 cases_progress"></mat-progress-bar>
</div>